export const RU = {
  RESTORE: {
    TITLE: 'Восстановление доступа',
    IIN_SUBTITLE: 'Введите ИИН, указанный при регистрации в интернет-банкинге',
    PHONE_SUBTITLE: 'Введите номер телефона, указанный при регистрации в интернет-банкинге',
  },
  AUTH: {
    LOGIN_TITLE: 'Вход',
    LOGIN_SUBTITLE: 'в интернет-банкинг для бизнеса',
    REGISTER: 'Зарегистрироваться',
    LOGIN: 'Войти',
    SET_PASSWORD: 'Установка пароля',
    LOGIN_OB_BROWSER: 'для входа в Optima Business через браузер',
    UNEXPECTED_ERROR: 'Непредвиденная ошибка системы. Повторите действия позже.',
    NOT_FOUND_COMPANY: 'Информация о компаниях отсутствует',
    CHECK: {
      CAPSLOCK: 'Включен Caps Lock ',
      LANGUAGE: 'Проверьте язык ввода',
      CAPSLOCK_AND_LANGUAGE: 'Проверьте язык ввода и Caps Lock',
    },
    PASSWORD: {
      TITLE: 'Пароль',
    },
    INVALID: 'Неверный ID клиента или пароль',
    ENTER_ID: 'Введите ID клиента',
    ENTER_PASSWORD: 'Введите пароль',
    CODE: {
      SEND_NEW: 'Получить новый код',
    },
    TOTP_CODE: {
      ERROR: 'Неверный TOTP-код. Пожалуйста, попробуйте еще раз.',
    },
    LOCK: {
      DATA_VERIFICATION: 'Подождите, пока мы проверяем данные',
      DATA_VERIFICATION_LABEL: 'Если всё в порядке, раздел станет доступен после проверки',
    },
  },
  PERSONAL_QR: {
    TITLE: 'Персональный QR',
    SOON: {
      TITLE: 'Скоро здесь появится персональный QR-код',
      TEXT: 'Сможете создавать QR-коды для каждого клиента с указанием назначения платежа - за что, для кого и на какую сумму',
    },
  },
  RESET_PASSWORD: {
    TITLE: 'Сброс пароля',
    SUB_TITLE: 'для входа в Optima Business',
    PHONE: 'Введите свой номер телефон',
    FINISH: {
      TITLE: 'Ваш пароль был сброшен!',
      SUB_TITLE: 'На ваш номер телефона был выслан одноразовый пароль для входа в систему и установки нового пароля',
    },
    SMS_CODE: {
      CONFIRMATION: 'SMS подтверждение',
      ENTER: 'Введите код из SMS, отправленный на ваш номер телефона',
      GET_NEW: 'Получить новый код можно через {countdown} сек',
      OUTDATED: 'SMS-код устарел',
      REQUEST: 'Запросите новый код на ваш номер телефона',
    },
  },
  HELP: {
    TITLE: 'Помощь',
    CONTACTS: 'Контакты',
    CALL_CENTRE: 'Колл-центр',
    CALL_NUMBER: 'Позвонить по номеру',
    CHAT_SUPPORT: 'Чат-поддержка',
    WRITE_WHATSAPP: 'Написать в WhatsAp',
    USER_MANUAL: 'Руководство по авторизации',
  },
  SESSION: {
    CONTINUE: 'Хотите продолжить сеанс?',
    EXPIRE: 'Ваш сеанс истекает через',
  },
  DIRECTORY: {
    DICTIONARY: 'Справочник',
  },
  INFORMATION: {
    PHONE: 'Номер телефона',
    PHONES: 'Номера телефонов',
    PARTY_ID: 'ID клиента',
  },
  CITY: 'Бишкек',
  DIALOG: {
    TO_MAIN: 'На главную',
    RETURN: 'Вернуться',
    TRY_AGAIN: 'Попробовать еще раз',
    RETURN_HISTORY: 'Вернуться в историю',
    TO_PAYMENT_CREATE: 'В создание операций',
    SAVE_TEMPLATES: 'Сохранить в шаблоны',
    EXIT: 'Выйти',
    CANCEL: 'Отмена',
  },
  SHARED: {
    SOON: {
      TITLE: 'Скоро будет',
      SUB_TITLE: 'Пожалуйста, подождите',
    },
    NOT_ENOUGH_CHARACTERS: 'Недостаточно символов',
    COMMISSION: 'Комиссия',
    TOTAL: 'Итого',
    AMOUNT_FROM: 'Сумма от',
    MOUNT_TO: 'Сумма до',
    DATE_FROM: 'Дата от',
    DATE_TO: 'Дата до',
    TIME_FROM: 'Время от',
    TIME_TO: 'Время до',
    TIME: 'Время',
    ALL: 'Все',
    COMMISSION_BANK: 'Комиссия банка',
    INTERFACE_LANG: 'Язык интерфейса',
    DATETIME: 'Дата и время',
    OPERATION_HISTORY: 'История операций',
    OPERATIONS: 'Операции',
    NO_DATA: 'нет данных',
    ACTION: {
      CHOOSE: 'Выбрать',
      ACCEPT: 'Принять',
      RETURN: 'Вернуться',
      EDIT: 'Редактировать',
      CHANGE: 'Изменить',
      OK: 'Ок',
      YES: 'Да',
      NO: 'Нет',
      ICON_PDF: 'Скачать PDF',
      CONFIRM: 'Подтвердить',
      CREATE: 'Создать',
      RECREATE: 'Пересоздать',
      IMPORT: 'Импорт',
      CLOSE: 'Закрыть',
      APPLY: 'Применить',
      RESET: 'Сбросить',
      RETRY: 'Обновить',
      ACCESSIBLY: 'Понятно',
      CONTINUE: 'Продолжить',
      CANCEL: 'Отмена',
      EXIT: 'Выйти',
      OPEN: 'Открыть',
      FORGOT_PASSWORD: 'Забыли пароль?',
      CANCELED: 'Отменить',
      ADD: 'Добавить',
      LOOK: 'Посмотреть',
      DOWNLOAD: 'Скачать',
      BACK: 'Назад',
      DELETE: 'Удалить',
      REPEAT: 'Повторить',
      REVOKE: 'Отклонить',
      SIGN: 'Подписать',
      FOR_SIGN: 'На подпись',
      SAVED: 'Сохранить',
      NEXT: 'Далее',
      DONE: 'Готово',
      SWITCH: {
        ON: 'Вкл.',
        OFF: 'Выкл.',
      },
      CHOOSE_TEMPLATE: 'Выбрать из шаблонов',
      WRITE_OFF: 'Списать',
      SAVE_TEMPLATE: 'Сохранить шаблон',
      ENROLL: 'Зачислить',
      RELOAD: 'Перезагрузить',
      GOOD: 'Хорошо ',
      COPY: 'Данные скопированы',
      COPY_ACTION: 'Копировать',
      PAYMENTS: 'Платежи',
    },
    COMMENT: 'Комментарий',
    OUTGOING: 'Исходящие',
    INCOMING: 'Входящие',
    REQUISITE: 'Реквизит',
    RECEIPT_NUMBER: 'Номер квитанции отправителя',
    SENDER_ACCOUNT: 'Счет отправителя',
    AMOUNT_AFTER_COMMISSION: 'Сумма после комиссии',
    ABOUT_PAYMENT: 'О платеже',
    FOUND: 'Найден',
    CREATED: 'Создано',
    ENROLLMENT_ACCOUNT: 'Счет зачисления',
    CHANGES_SAVED: 'Изменения сохранены',
    READY: 'Готово!',
    AGREE_FOR_CONTINUE: 'Для продолжения, подтвердите  информацию ниже',
    SORTING: 'Сортировка',
    FULL_NAME: 'ФИО',
    CREATED_DATE: 'Дата создания',
    ADDRESS: 'Адрес',
    CITY: 'Город',
    ACTUAL_ADDRESS: 'Адрес фактического проживания',
    PCS: 'шт',
    MAIN: 'Основное',
    PHOTO: 'Фото',
    BACK: 'Назад',
    ACCOUNT_NUMBER: 'Номер счета',
    DOWNLOAD: 'Скачать',
    DEPOSITS: 'Депозиты',
    INFORMATION: 'Информация',
    GENERAL: 'Общие',
    SECURITY: 'Безопасность',
    USER_ACCOUNT: 'Аккаунт',
    STATUS: 'Статус',
    NUMBER: 'Номер',
    NUMBER_SYMBOL: '№',
    TYPE: 'Тип',
    EXIT: 'Выход',
    CREATE: 'Создать',
    PRODUCTS: 'Продукты',
    LOOK: 'Посмотреть',
    SEE_ALL: 'Смотреть все',
    IMPORT: 'Импорт',
    RETRY: 'Обновить',
    CONTINUE: 'Продолжить',
    CANCEL: 'Отмена',
    CANCELED: 'Отменить',
    CONFIRM: 'Подтвердить',
    PHONE: 'Телефон',
    INN: 'ИНН',
    REGION: 'Район',
    AIYL_AREA: 'Айыльный аймак',
    KBK: 'Код бюджетной классификации',
    PASSWORD: 'Пароль',
    ACCOUNT_PASSWORD: 'Пароль от аккаунта',
    DONE: 'Готово',
    FORGOT_PASSWORD: 'Забыли пароль?',
    CONTRACT: 'Договор',
    REMAINDER: 'Остаток',
    YES: 'Да',
    NO: 'Нет',
    OK: 'Ok',
    CURRENCY: 'Валюта',
    DOCUMENT_NUMBER: 'Номер документа',
    SUM: 'Сумма',
    RATE: 'Курс',
    FILTER: {
      TITLE: 'Фильтр',
      SEARCH: 'Искать',
      APPLY: 'Применить',
      RESET: 'Сбросить',
    },
    TOTP: {
      CODE: 'TOTP-код',
      ENTER_CODE: 'Введите сгенерированный код TOTP',
      INVALID_TOTP: 'Неверный TOTP-код. Пожалуйста, попробуйте еще раз.',
    },
    SWITCH: {
      ON: 'Вкл.',
      OFF: 'Выкл.',
    },
    SAVE: {
      SAVED: 'Сохранить',
      SUCCESSFUL: 'Успешно сохранен',
      CHANGES: 'Сохранить изменения',
    },
    SMS: {
      TITLE: 'SMS',
    },
    SIGN_TYPE: {
      ONE_SIGNATORY: 'Один подписант',
      TWO_SIGNATORY: 'Два подписанта',
    },
    SIGN_RIGHT: {
      AUDITOR: 'Аудитор',
      CREATOR: 'Исполнитель',
      FIRST: '1-подпись',
      SECOND: '2-подпись',
      THIRD: '3-подпись',
      NONE: 'Без подписи',
      CASH_MANAGER: 'Менеджер',
      CASHIER: 'Кассир',
    },
    ERROR_PLACEHOLDER: {
      SUBTITLE: 'Попробуйте обновить страницу',
      TITLE: 'Ошибка сервера',
    },
    SYSTEM_ERROR: 'Непредвиденная ошибка системы. Повторите действия позже',
    ACCOUNT: {
      TITLE: 'Мои продукты',
      RKO: 'Счет',
      CARD: 'Карта',
      DEPOSIT: 'Депозит',
      SETTLEMENT_ACCOUNTS: 'Счета',
      CARDS: 'Карты',
    },
    RULE: {
      FILL_FIELD: 'Заполните поле!',
      FILL_LATIN: 'Заполните поле на латинице!',
      NEW_OLD_PASSWORD_REPEATED: 'Новый пароль должен отличаться от текущего.',
      CONVERSION_AMOUNT_EXCEEDS_BALANCE: 'Сумма конвертации превышает доступный баланс счета',
      PAYMENT_AMOUNT_EXCEEDS_BALANCE: 'Сумма платежа превышает доступный баланс счета',
      ACCOUNT_INSUFFICIENT_FUNDS: 'Недостаточно средств на счете',
      INCORRECT_DATE: 'Некорректная дата',
      INCORRECT_TIME: 'Некорректное время',
      INCORRECT_SYMBOLS: 'Недопустимые символы {value}',
      INCORRECT_MANUAL_RATE: 'Некорректный договорной курс',
      INCORRECT_PERCENTAGE_DIFFERENCE: 'Недопустимое значение!',
      NO_ACCESS_OPERATION: 'Нет доступа к операции!',
      FORBIDDEN_SEND_EXTERNAL_ACCOUNT: 'Запрещено отправлять на внешние счета',
      SAME_DEBIT_ACCOUNT: 'Совпадает со счетом списания',
      TIME_EXPIRED: 'Ограничение по времени. Операция недоступна.',
      PAY_CONTROL_NOT_EXIST:
        'В мобильном приложении нет возможности использовать подписание Rutoken или TOTP. Пожалуйста подпишите операцию на сайте',
      PAY_CONTROL_NOT_AVAILABLE:
        'Невозможно отправить платеж на подпись. У одного из подписантов отсутствует PayControl.',
      INCORRECT_INN: 'Некорректный ИНН',
      INCORRECT_DATA: 'Некорректные данные',
      INCORRECT_PASSWORD: 'Неверный пароль',
      ONE_YEAR_PERIOD: 'Вы можете выбрать период только за 1 год',
      MONTH_PERIOD: 'Вы можете выбрать период только за 31 день',
      MAX_LENGTH: 'Максимальная длина ввода символов {length}',
      MIN_LENGTH: 'Минимальная длина ввода символов {length}',
      CLIENT_NOT_FOUND: 'Клиент не найден. Проверьте корректность введенных данных',
      IBAN: 'Структура счета не соответствует стандарту IBAN',
      OUTLET_CHECK: 'Подойдут только буквы, цифры, пробел и тире',
      NOT_EMOJI: 'Эмодзи не подойдут',
    },
    SEARCH: 'Поиск',
    TIME_LIMIT: 'Создать платёж можно с {timeFrom} до {timeTo}',
    VALUE_DATE: 'Дата валютирования',
    AMOUNT_PAYMENT: 'Сумма платежа',
    ACCOUNT_NOT_FOUND: 'Счет не найден!',
    CHOOSE_TEMPLATE: 'Выбрать из шаблонов',
    NAME_LEGAL_ENTITY: 'Наименование плательщика',
    WITHDRAWAL_ACCOUNT: 'Счет списания',
    RECIPIENT: 'Получатель',
    RECIPIENT_NAME: 'Имя получателя',
    APPOINTMENT: 'Назначение',
    TYPE_TRANSACTION: 'Тип операции',
    ENROLL: 'Зачислить',
    WRITE_OFF: 'Списать',
    PAYMENT_CODE: 'Код платежа',
    SAVE_TEMPLATE: 'Сохранить шаблон',
    NAME: 'Наименование',
    PAYMENT_DETAILS: 'Детали платежа',
    OPERATION_DETAILS: 'Детали операции',
    INVOICE_COMMISSION_PAYMENT: 'Счет для оплаты комиссии',
    PAYER: 'Плательщик',
    CLOSE: 'Закрыть',
    BIN: 'БИН',
    KPP: 'КПП',
    BIC_SWIFT: 'БИК/SWIFT',
    BIC_SWIFT_INTERMEDIARY: 'БИК/SWIFT банка-посредника',
    NOT_FOUND: 'Данные не найдены',
    MORE: 'больше',
    LESS: 'меньше',
    DETAILED_INFO_BY_CALL_CENTER:
      'Более подробную информацию вы можете получить через контакт центр банка по номеру 9500',
    WEEK: {
      MON: 'ПН',
      TUE: 'ВТ',
      WED: 'СР',
      THU: 'ЧТ',
      FRI: 'ПТ',
      SAT: 'СБ',
      SUN: 'ВС',
    },
    CONFIRM_CLOSE_TITLE: 'Хотите выйти?',
    CONFIRM_EXIT_TITLE: 'Вы действительно хотите выйти?',
    NOT_HAVE_PRODUCTS: 'У вас еще нет продуктов в Optima Business',
  },
  CALCULATOR: {
    CURRENCY_CONVERTOR: 'Калькулятор валют',
    TYPE_RATE: 'Вид курсов',
  },
  FORM_PAYMENT: {
    NOT_ENOUGH_MONEY: 'На счёте не хватает денег',
    NOT_ENOUGH_MONEY_DESCRIPTION:
      'Планируемый остаток: {plannedBalance} {currency}.\nВведите другую сумму или пополните счёт.',
    NOT_ENOUGH_MONEY_BUTTON: 'Я введу другую сумму',
    INSUFFICIENT_FUNDS_DIALOG: {
      SINGLE_PAYMENT_TITLE: 'Недостаточно средств для отправки платежа на подпись',
      PAYMENT_AMOUNT: 'Сумма платежа:',
      AVAILABLE_BALANCE: 'Доступный остаток:',
      DESCRIPTION: 'Вы можете изменить платеж или продолжить отправку на подпись',
      EDIT: 'Отредактировать',
      CONTINUE: 'Продолжить',
    },
    CONVERSION: {
      PURCHASE: 'Установленный курс покупки',
      CONTRACTUAL_PURCHASE: 'Договорной курс покупки',
      SALES: 'Установленный курс продажи',
      CONTRACTUAL_SALES: 'Договорной курс продажи',
      CONVERSION: 'Установленный курс конвертации',
      CONTRACTUAL_CONVERSION: 'Договорной курс конвертаций',
      ENROLLMENT_ACCOUNT: 'Счет зачисления',
      DIDNT_LOAD: 'Курс не загрузился.<br/>Пожалуйста, обновите курс конвертации',
      RESET_VALUE_RATE: 'Вернуться к установленному',
      TEXT_INFO_CONVERSION: 'Если сумма больше 10 000 USD, можно установить договорной курс',
    },
    TRANSFER: {
      PAYMENT_CODE: {
        LABEL: 'Код оплаты',
        HINT: 'Выберите код, соответствующий назначению. Поиск выполняется по коду и наименованию',
      },
      PAYING_GOODS_SERVICES:
        'При оплате за товары/услуги укажите наименование товаров, работ, услуг, номера и даты договоров/счетов',
      BIC_BANK_NAME: 'БИК/Наименование банка',
      NAME_RECIPIENT: 'Наименование получателя',
      NOT_OPERATION_TYPE: 'Выберите тип операции',
      AVAILABLE_UNTIL: 'Доступен с {timeFrom} до {timeTo}',
      MAX_AMOUNT_ONE_MILLION: ' Максимальная сумма до 1 млн сом',
      FORBIDDEN_SYMBOL: '& является запрещенным символом.',
      INTRABANK_RKO_TO_CARD_NOT_ALLOWED: 'Счет является карточным. Пожалуйста, введите расчетный счет.',
      ACCOUNT_NOT_EXIST_FOR_OPERATION:
        'Для выбранного счета списания недоступен данный тип операции "{operation}". Для получения доступа, обратитесь к первому подписанту.',
    },
    SWIFT: {
      COUNTRY: 'Страна',
      CORRESPONDENT_ACCOUNT: 'Корреспондентский счет',
      NAME: 'Наименование',
      ACCOUNT_IBAN: 'Счет/IBAN',
      CURRENCY_TRANSACTION_CODE: 'Код валютной операции VO',
      INTERMEDIARY_BANK: 'Банк-посредник',
      EXOTIC_CURRENCY: 'Экзотическая валюта',
      AVAILABLE_DEBIT_ACCOUNT_IS_EURO: 'Доступен, если валюта счета списания - евро',
      CROSS_RATE: 'Кросс-курс',
      PAYMENT_CODE: {
        LABEL: 'Код оплаты',
        HINT: 'Выберите код, соответствующий назначению. Поиск выполняется по коду и наименованию',
      },
      CARGO:
        'Обязуюсь предоставить ОАО "Оптима Банк" официальный документ, подтверждающий поставку товара на территорию Кыргызской Республики по настоящему переводу в течение 3 (трёх) рабочих дней после поставки товара (для переводов за товар)',
      TRANSFER_BETWEEN_BANKS: 'Переводы между банками КР выполняются с обязательным указанием банка - посредника',
      RUS_USD_EUR_NOT_ALLOWED: 'Переводы в Российскую Федерацию в долларах США (USD) и евро (EUR) временно недоступны',
      RUS_USD_EUR_WARNING:
        'Уважаемые клиенты! SWIFT-переводы в Российскую Федерацию в USD и EUR временно недоступны. По вопросам альтернативных расчетов обращайтесь в подразделение Банка',
      HINT_NAME: 'Вводите "Адрес" и "Город" только в соответствующие поля выше!',
    },
    O24_TRANSFER: {
      BY_PHONE_NUMBER: 'По номеру телефона',
      BY_CARD_NUMBER: 'По номеру счета',
    },
    LOADING: {
      DRAFT: 'Платеж сохраняется в черновик',
      SIGNED: 'Платеж отправляется на подпись',
    },
    LIMITS: {
      ONE_TIME: 'Вы превысили разовый лимит!',
      DAILY: 'Вы превысили лимит на день!',
      MONTHLY: 'Вы превысили лимит на месяц!',
      FOR_DAY: 'Вы превысили лимит на день!',
      FOR_MONTH: 'Вы превысили лимит на месяц!',
    },
    REMOTELY_IDENTIFIED_EXCEPTION: {
      MONTHLY: {
        TITLE: 'Лимит на переводы в месяц исчерпан',
        SUBTITLE: 'Подтвердите аккаунт в офисе банка,чтобы снять ограничения',
      },
      FOR_MONTH: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.SUBTITLE',
      },
      ONE_TIME: {
        TITLE: 'Слишком большая сумма перевода',
        SUBTITLE: 'Попробуйте ввести сумму меньше или подтвердите аккаунт в офисе банка, чтобы снять ограничения',
      },
      OPERATION_NOT_AVAILABLE: {
        TITLE: 'Переводить можно только на свои карты',
        SUBTITLE: ' Подтвердите аккаунт в офисе банка, чтобы снять ограничения',
      },
      DAILY: {
        TITLE: 'Лимит исчерпан',
        SUBTITLE: 'Вы превысили лимит на день!',
      },
      FOR_DAY: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.SUBTITLE',
      },
    },
    CONFIRM_TRANSFER: {
      TITLE: 'Подтвердите перевод',
      DESCRIPTION: 'Обменный курс предварительный и может измениться при расчёте',
      TRANSFER_AMOUNT: 'Сумма перевода',
      CREDITED_AMOUNT: 'Будет зачислено',
      CONVERSION_RATE: 'Курс конвертации ',
    },
    EDITING: 'Редактирование платежа',
  },
  PAYMENT_DETAILS: {
    VALUE_DATE: 'Дата валютирования',
    DOCUMENT: '№ документа',
    WRITE_OFF_AMOUNT: 'Сумма списания',
    RATE_OPERATION: 'Курс операции',
    CREATED: 'Создано',
    ENROLLMENT_AMOUNT: 'Сумма зачисления',
    BANK: 'Банк',
    BIC: 'БИК',
    ACCOUNT: 'Счет',
    CARD_ACCOUNT: 'Карточный счет',
    CARD_NUM: 'Номер карты',
    KBK: 'КБК',
    PURPOSE: 'Назначение платежа',
    CORPORATE_ACCOUNT: 'Корреспондентский счет',
    RECIPIENT_COUNTRY: 'Страна получателя',
    COMMISSION: 'Комиссия',
    COMMISSION_CURRENCY: 'Валюта комиссии',
    COMMISSION_ACCOUNT: 'Счет комиссии',
    PAYMENT_CODE: 'Код оплаты',
    OPERATION_ID: 'ID операции',
    EXOTIC_RATE: 'Курс экзотики(кроме USD,EUR,RUB,CNY,KZT,GBP,СNY,JPY)',
    OPTION: 'Опция',
  },
  PASSWORD_WITH_REPEAT: {
    THINK_UP_PASSWORD: 'Новый пароль',
    REPEAT_PASSWORD: 'Повторите новый пароль',
    PASSWORD_MISMATCH: 'Несовпадение паролей',
  },
  REVOCATION_REASON_PAYMENT: {
    REASON_FOR_RECALL: 'Причина отзыва',
    ENTER_REASON: 'Введите причину',
  },
  SELECTION_PAYMENT_HEADER: {
    SELECT_ALL: 'Выбрать все',
    OPERATIONS: 'Операций',
    FOR_AMOUNT: 'На сумму',
    OPERATION: 'операции',
  },
  VISIBLE_ACCOUNT_LIST: {
    MISSING_ACCOUNT: 'Отсутствуют счета',
    ACCOUNT_VISIBILITY: 'Видимость счета',
  },
  PAYMENT_ACTION: {
    MB_TRANSFER_SOM: 'Межбанк перевод в сомах',
    MB_TRANSFER: 'Межбанк перевод в валюте',
    CONVERSION: 'Конвертация',
    INTRABANK_TRANSFER: 'Внутрибанковский перевод',
    OWN_CARD_TRANSFER: 'Перевод на Бизнес карту',
    O24_TRANSFER: 'Перевод на Оптима24',
    CARD_RKO_TRANSFER: 'Перевод с Бизнес карты на расчетный счет',
    TRANSFER_BY_INVOICE: 'Оплата счета на оплату',
    NOT_ALLOWED_BY_SIGN_RIGHT: 'Ваша роль не предусматривает возможность создания платежей',
  },
  BUDGET: {
    TITLE: 'Бюджетные платежи',
    DATE_EXPIRED:
      'Создание операции на текущую дату валютирования недоступно. Желаете создать операцию на следующий рабочий день - {date}?',
    GNS: {
      TITLE: 'Налоговые платежи ГНС',
      OTHER_TAX: 'Оплата других налогов',
      CHATTEL_TAX: 'Оплата налога на движимое имущество',
      REALTY_TAX: 'Оплата налога на недвижимое имущество',
      PAYMENT: 'Оплата по коду оплаты',
    },
    TUNDUK: {
      TITLE: 'Оплата за услуги ГПЭУ Тундук',
    },
    AIS_FOREST_USE: 'АИС "Лесопользование"',
    GUARANTEE_FEE_ETP_FUGI: 'Гарантийный взнос (ЭТП ФУГИ)',
    E_PATENT: 'Электронный патент',
    GUARANTEE_FEE_ETP_MSU: 'Оплата гарантийного взноса (ЭТП МСУ)',
    SOCIAL_INSURANCE_PAYMENT: 'Оплата за соц.страхования',
    INSURANCE_CONTRIBUTION_PAYMENT_BY_CODE: 'Оплата за страховой взнос по коду оплаты',
    ELECTRONIC_NOTARY: 'Электронный нотариат',
    BUDGET_CREDIT_REPAYMENT: 'Погашение бюджетных кредитов',
    JUDICIAL_DEPARTMENT_GUARANTEE_FEE: 'Суд. деп-т при ВС - оплата гарантийного взноса для участия в торгах',
    JUDICIAL_DEPARTMENT_PROPERTY_PAYMENT: 'Суд. деп-т при ВС - оплата стоимости имущества',
    JUDICIAL_DEPARTMENT_ENFORCEMENT_FEE_10_PERCENT: 'Судебный департамент Оплата 10% исполнительского сбора',
    DEADLINE_HINT:
      'С момента начала заполнения, оформите и подпишите платёж в течение следующих 15 минут. Если не подписать вовремя, платёж не будет обработан',
    SOON: 'Скоро будет!',
    PLEASE_WAIT: 'Пожалуйста, подождите',
    FORM: {
      INPUT_REGION: 'Выберите район',
      INPUT_TAX_TYPE: 'Выберите вид налога',
      INPUT_AMOUNT_PAYMENT: 'Введите сумму',
      INPUT_AIYL_AREA: 'Выберите Айыльный аймак',
      INPUT_WRITE_OFF: 'Счет списания',
      AMOUNT_PAYMENT: 'Сумма оплаты',
      TAX_TYPE: 'Вид налога',
      TAX_SUM: 'Сумма налога',
      ENICODE: 'Еникод',
      COEFFICIENT_FUNC_PURPOSE: 'Коэффициент функционального назначения',
      BOOK_VALUE: 'Балансовая стоимость',
      PERSONAL_ACCOUNT: 'Лицевой счет',
      CODE_PAYMENT: 'Код оплаты',
    },
    MAX_AMOUNT: 'Максимальная сумма {value}',
    MIN_AMOUNT: 'Минимальная сумма {value}',
    PAYMENT_DEADLINE: 'Код оплаты действителен только в день создания — до 23:59:59.',
    PAYMENT_DEADLINE_ERROR:
      'Введите действующий код оплаты. Учтите, что код работает только в день создания — до 23:59.',
  },
  FOOTER: {
    COPYRIGHT: 'ОАО «Оптима Банк»',
    YEARS: '© 1992-{year} гг.',
  },
  LANGUAGE: {
    RU: 'Русский',
    KG: 'Кыргызча',
    ENG: 'English',
  },
  HOME: {
    TITLE: 'Главная',
  },
  HISTORY: {
    TITLE: 'Мои операции',
    STATUS: {
      CREATION: 'Создание',
      DRAFT: 'Черновик',
      TO_DRAFT: 'В черновик',
      PARTIALLY_CONFIRMED: 'На подписании',
      PARTIALLY_CONFIRMED_SUFFIX: 'Вам на подпись',
      ON_VERIFICATION: 'На подписании',
      ON_VERIFICATION_SUFFIX: 'Вам на подпись',
      PARTIAL_CONFIRMATION_COMPLETED: 'Подписано 2-ым',
      PARTIAL_CONFIRMATION_COMPLETED_SUFFIX: 'Подписано 2-ым',
      ON_VERIFICATION_COMPLETED: 'Подписано 1-ым',
      ON_VERIFICATION_COMPLETED_SUFFIX: 'Подписано 1-ым',
      CANCELED_SIGN_TWO: 'Отменен 2-ым',
      CANCELED_SIGN_ONE: 'Отменен 1-ым',
      FOR_EDITING: 'Отправлен на редактирование',
      REJECTED_SUFFIX: 'Вам на редактирование',
      CONFIRMED: 'Подписан',
      REVOKE: 'Отозван',
      WAIT_RESPONSE_FROM_BANK: 'В обработке',
      CHECK_STATUS_BANK: 'Проверка ответа Банка',
      PAYMENT_REQUEST_TO_BANK: 'Отправляется в Банк',
      KVIT: 'Исполнен Банком',
      SUCCESS: 'Завершен',
      ERROR: 'Отказан Банком',
      UNKNOWN: 'Ошибочный статус',
      FIRST_SIGN_IN_PAY_CONTROL: 'Отправляется на подпись',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE: 'На подписании',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'Вам на подпись',
      SECOND_SIGN_IN_PAY_CONTROL: 'Отправляется на подпись',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE: 'На подписании',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'Вам на подпись',
      TIMEOUT_CANCELED_SIGN_TWO: 'Отказ по таймауту',
      TIMEOUT_CANCELED_SIGN_ONE: 'Отказ по таймауту',
      PARTIALLY_EXECUTED: 'Выполнена частично',
      TIME_IS_OUT: {
        TITLE: 'Отказано по истечению времени',
        ERROR: 'Платёж не прошел проверку по времени, просьба повторить попытку',
      },
    },
    STATUS_HISTORY: {
      DRAFT: 'Создан',
      PARTIAL_CONFIRMATION_COMPLETED: 'Подписан 2-ым',
      ON_VERIFICATION_COMPLETED: 'Подписан',
      ON_VERIFICATION_COMPLETED_SUFFIX: 'Подписан 1-ым',
      CANCELED_SIGN_TWO: 'Отменен 2-ым',
      CANCELED_SIGN_ONE: 'Отменен 1-ым',
      WAIT_RESPONSE_FROM_BANK: 'В обработке',
      PAYMENT_REQUEST_TO_BANK: 'Запрос на выполнение',
      TIMEOUT_CANCELED_SIGN_TWO: 'Отказ по таймауту',
      TIMEOUT_CANCELED_SIGN_ONE: 'Отказ по таймауту',
      REVOKE: 'Отозван',
      KVIT: 'Исполнен Банком',
      SUCCESS: 'Завершен',
      ERROR: 'Отклонен',
    },
    LISTS: {
      ALL: 'Все',
      DRAFT: 'Мои черновики',
      DRAFT_SALARY: 'Готов к подписанию',
      FAILED: 'Отклоненные',
      ERROR: 'Отказано Банком',
      FOR_SIGN: 'На подпись',
      FOR_EDITING: 'На редактирование',
      SUCCESS: 'Исполненные',
    },
    NOTIFICATIONS: {
      SIGNED: {
        SUCCESS: 'Платеж {number} подписан',
        SUCCESS_MULTIPLE: 'Платежи подписаны',
        SUCCESS_PARTIAL: 'Платежи частично подписаны',
        ERROR: 'Не удалось подписать платеж',
        ERROR_MULTIPLE: 'Не удалось подписать платежи',
      },
      SEND_TO_SIGNED: {
        SUCCESS: 'Платеж {number} отправлен на подпись',
        SUCCESS_MULTIPLE: 'Платежи отправлены на подпись',
        ERROR: 'Не удалось отправить платеж на подпись',
        ERROR_AFTER_DRAFT: 'Операция создана как черновик и подлежит подписанию из истории операций',
        ERROR_MULTIPLE: 'Не удалось отправить платежи на подпись ',
      },
      SAVED_TO_DRAFT: {
        SUCCESS: 'Платеж {number} сохранен в черновике',
        ERROR: 'Не удалось сохранить платеж в черновике',
      },
      DELETE_DRAFT: {
        SUCCESS: 'Черновик {number} удален',
        ERROR: 'Не удалось удалить черновик',
      },
      FOR_EDITING: {
        SUCCESS: 'Платеж {number} отклонен',
        ERROR: 'Не удалось отклонить платеж',
      },
      SEND_TO_EDITING: {
        SUCCESS: 'Платеж {number} отправлен на редактирование',
        ERROR: 'Не удалось отправить платеж на редактирование',
      },
      SUCCESS_EDITING: {
        SUCCESS: 'Платеж успешно отредактирован',
        ERROR: 'Не удалось отредактировать платеж',
      },
    },
    TRANSACTION: {
      PAYMENTS_SIGNED: 'Платежи подписывается...',
      PAYMENT_SIGNED: 'Платеж № {number} подписывается...',
      PAYMENT_CANCELLED: 'Платеж № {number} отменяется...',
      PAYMENT_SENT_EDITING: 'Платеж № {number} отправляется на редактирование...',
      PAYMENT_SENT_SIGNING: 'Платеж № {number} отправляется на подписание...',
      FILE_DOWNLOADING: 'Скачивается файл...',
      FILE_OPENING: 'Открывается файл...',
      PAYMENT_REMOVING: 'Платеж № {number} удаляется...',
      PAYMENT_SENT_SIGN: 'Платеж отправляется на подписание...',
      PAYMENTS_SENT_SIGN: 'Платежи отправляются на подписание...',
      PAYMENTS_RESPOND: 'Платежи отзываются...',
      PAYMENT_RESPOND: 'Платеж отзывается...',
      PAYMENT_UPDATING: 'Платеж № {number} обновляется...',
      PAYMENT_RECALL: 'Платеж отозван на редактирование',
      PAYMENT_RECALLING: 'Платеж отзывается...',
      ERROR: {
        FOR_SIGN: 'Не удалось отправить на подписание',
        PAYMENT_RECALL: 'Не удалось отозвать платеж',
      },
    },
  },
  FILE_UPLOAD: {
    LOADING: 'Загрузка файла...',
    FILE_SIZE_EXCEPTION: 'Размер файла превышает допустимое значение.',
    FILE_EXTENSION_EXCEPTION: 'Расширение файла не соответствует ожидаемому.',
    FAILED_SAVE_FILE: 'Не удалось сохранить файл',
    IN_IMPORTED: 'В импортированные',
    FILE_SAVED_SUCCESSFULLY: 'Файл успешно сохранен',
  },
  HISTORY_PAYMENT_QR: {
    EXTRACT_FORMAT: 'Выберите формат',
    DOWNLOAD_STATEMENT: 'Скачать выписку',
    TITLE: 'Платежи по QR-коду',
    EXTRACT_EXCEL: 'Экспорт в Excel',
    VALIDATION_ERROR_DATE: 'Укажите в фильтрах обе даты или период времени для экспорта в Excel',
    ENROLLED: 'Зачислено',
    TYPE_TRANSACTION: 'Тип транзакции',
    TYPE_QR_POS: 'Тип QR и номер POS',
    POS_NUMBER: 'Номер POS терминала',
    QR_SERVICE_TYPE: {
      STATIC: 'Статический',
      DYNAMIC: 'Динамический',
      OVERHEAD: 'Оплата по накладной',
      WEB: 'Оплата онлайн-платежей',
      MONITOR: 'Оплата оффлайн в кассе',
      INVOICE: 'Счет на оплату',
      PERSONAL_QR_WEB: 'Персональный QR',
      DEEPLINK_QR: 'Диплинк QR',
    },
    STATUS_SUCCESS: 'Исполнен',
    PAYMENT_FOR_OPTIMA_QR: 'Платеж по OptimaQR от {senderName}',
    PAYMENT_FOR_QR: 'Платеж по QR-коду',
    EMPTY_HISTORY: 'Список операций пуст',
    SORTED: {
      TITLE: 'Сортировка по сумме',
      NONE: 'Без сортировки',
      ASC: 'По возрастанию',
      DESC: 'По убыванию',
    },
    DATE_PERIOD: {
      RECENT: 'Недавние',
      WEEK: 'За 7 дней',
      MONTH: 'За 30 дней',
    },
    INCOME_TODAY: 'Доход за Сегодня',
    INCOME_YESTERDAY: 'Доход за Вчера',
    SALES_SHORT_LABEL: 'Кол-во продаж',
  },
  QR_REFUND: {
    ABOUT: 'О возврате',
    OUTLET_NAME_OR_ACCOUNT: 'Название точки продаж',
    OUTLET_ADDRESS: 'Адрес точки',
    RETURNED: 'Возвращено',
    TO_RETURN: 'К возврату',
    TO_CLIENT: 'Возврат клиенту',
    TO_CARD: 'Возврат на карту',
    TO_REFUND_CHECK: 'Чек возврата',
    CHECK_NUMBER: 'Номер чека',
    RETURN_CHECK_NUMBER: 'Номер возвратного чека',
    SUM: 'Сумма возврата ',
    PURPOSE: 'Причина возврата',
    HINT: 'Вы можете выполнить не более одного полного или частичного возврата',
    ONLY_O24: 'Вернуть можно только платёж по OptimaQR',
    ALREADY_RETURNED: 'По данному платежу уже был сделан возврат',
    IN_PROCESS: 'Возврат уже отправлен на подпись',
    RULES: {
      AMOUNT: 'Сумма возврата не может быть больше суммы исходного платежа',
      PURPOSE: 'Можно ввести от 4 до 140 символов и все спецсимволы, кроме этих: \\ «» & <>',
    },
    ERRORS: {
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY: 'Не хватает денег на счёте списания',
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY_HINT: 'Пополните счёт и попробуйте сделать возврат ещё раз',
      PAYER_ACCOUNT_BLOCKED: 'Счет списания закрыт или арестован',
      PAYER_ACCOUNT_BLOCKED_HINT: 'Если вы владелец, обратитесь в {department}, чтобы разблокировать счёт',
      RECIPIENT_ACCOUNT_BLOCKED: 'Счёт зачисления заблокирован',
      RECIPIENT_ACCOUNT_BLOCKED_HINT: 'Попросите клиента обратиться в службу поддержки, чтобы разблокировать счёт',
      RECIPIENT_ACCOUNT_INACTIVE: 'Счёт списания неактивен',
    },
  },
  QR_PAYMENT: {
    TITLE: 'Оплата по QR-коду',
    SUBTITLE: 'Оплата по QR',
    B2C_O24: 'Платеж B2C по OptimaQR',
    B2B_O24: 'Платеж B2B по OptimaQR',
    B2B_ELQR: 'Платеж B2B по ELQR',
    B2G: 'Платеж B2G',
  },
  SETTINGS: {
    TITLE: 'Настройки',
    MAIN: {
      PAY_CONTROL: 'Pay Control',
      VISIBILITY_ACCOUNT: 'Видимость счетов',
      CHANGE_PHONE: 'Изменить номер телефона',
      CODE_WORD: 'Кодовое слово',
      COMPANY: {
        TITLE: 'О компании',
        NAME: 'Наименование',
        SIGN_TYPE: 'Тип подписи',
        SIGN_SCHEME: 'Маршрут платежей',
        ID_COMPANY: 'ID Компании',
        DEPARTMENT_NAME: 'Филиал договора',
        REGISTER_DATE: 'Дата регистрации договора',
      },
      PRIVATE: {
        TITLE: 'Личные данные',
        NAME: 'ФИО',
        RIGHTS: 'Роль',
        EMAIL: 'Эл.адрес',
        PHONE: 'Номер телефона',
      },
      CONTACTS: {
        TITLE: 'Контакты банка',
        WHATS_APP: 'WhatsApp',
        PHONE: 'Тел.',
        EMAIL: 'E-mail',
      },
      PAYMENT: {
        TITLE: 'Регламент по времени',
        SUBTITLE: 'Временные ограничения для операций в Optima Business:',
        DESCRIPTION:
          'Пожалуйста, обратите внимание на указанные временные рамки при проведении операций в Optima Business. Соблюдение этих ограничений поможет избежать возможных задержек в обработке операций.',
        TYPE: {
          CLEARING: 'Клиринг',
          GROSS: 'Гросс',
          SWIFT: 'SWIFT',
          INTRABANK_TRANSFER_OWN: 'Внутрибанковские переводы на свои счета',
          INTRABANK_TRANSFER_FOREIGN: 'Внутрибанковские переводы на счета других клиентов Банка',
          RKO_2_BUSINESS_CARD_OWN: 'Перевод на Бизнес карту',
          INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Перевод на Бизнес карту',
          RKO_2_BUSINESS_CARD_FOREIGN: 'Перевод на Оптима24',
          RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Перевод на Оптима24',
          RKO_2_INDIVIDUAL_CARD_OWN: 'Перевод на Оптима24',
          BUSINESS_CARD_2_RKO_OWN: 'Перевод с Бизнес карты на расчетный счет',
          BUSINESS_CARD_2_RKO_FOREIGN: 'Перевод с Бизнес карты на расчетный счет',
          CONVERSION: 'Конвертация',
          BUDGET_PAYMENT: 'Бюджетные платежи',
          SALARY: 'Зарплатный проект',
          TRANSFER_BY_INVOICE: 'Оплата счета на оплату',
          REFUND: 'Возврат QR-платежа',
          QR: 'Платеж/перевод по QR',
        },
        DEFAULT: 'Другие валюты',
        CREATE_OPERATION: 'Создание операции',
        SIGN_OPERATION: 'Подписание операции',
        TIME: 'до {value}',
      },
    },
    CHANGE_PASSWORD: {
      TITLE: 'Сменить пароль',
      SUCCESSFULLY: 'Пароль успешно изменен',
      FAILED: 'Не удалось сменить пароль',
      CURRENT_OPT_INCORRECT: 'Текущий пароль или TOTP-код не верный!',
      LOGIN_OB: 'Пароль будет использован для входа в Optima Business',
      CURRENT: 'Текущий пароль',
    },
    CHANGE_PHONE: {
      NUMBER_OB: 'Смена номера телефона в Optima Business',
      SUCCESSFULLY: 'Номер телефона успешно изменен',
      TRY_ENTER_NEW: 'Попробуйте ввести новый',
      ENTER_CODE_SENT: 'Введите код, отправленный на новый номер телефона',
      NEW_OLD_SAME: 'Новый номер телефона повторяет ранее зарегистрированный',
      REGISTERED: 'Зарегистрированный номер телефона',
      NEW: 'Новый номер телефона',
      SMS_CODE: 'СМС-код',
    },
    VISIBILITY_ACCOUNT: {
      FAILED_CHANGE_ACCOUNT_VISIBILITY: 'Не удалось изменить настройку видимости счета',
      FAILED_GET_INVOICES: 'Не удалось получить счета',
    },
    PAY_CONTROL: {
      INFO: 'Информация по Pay Control',
      REGISTRATION: 'Регистрация Pay Control',
      SUCCESS_GENERATED: 'Успешно сгенерирован Pay Control',
      ERROR: 'Ошибка при генерации Pay Control',
      IDENTIFIER: 'Идентификатор:',
      VALIDITY: 'Срок действия:',
      REISSUE_KEY: 'Перевыпустить ключ',
      RELEASE_KEY: 'Выпустить ключ',
    },
    API_KEY: {
      TITLE: 'Ключ (API Key)',
      HELP: {
        LABEL: 'Что такое API Key',
        DESCRIPTION: 'Это код из букв и цифр, который позволяет обмениваться данными в зашифрованном виде',
      },
      DIALOG: {
        SAVE: {
          TITLE: 'Подтвердите, что сохранили ключ API Key',
          MESSAGE: 'Нажмите "Ключ скопирован и сохранен", а затем "Готово"',
        },
        WARNING: {
          TITLE: 'Хотите пересоздать ключ?',
          MESSAGE: 'Пересоздание удалит нынешний активный ключ',
        },
      },
      HINT: 'Так вы будете иметь к нему доступ. Ключ активен 90 дней',
      KEY: 'Ключ',
      KEY_TYPE: 'Тип ключа',
      KEY_STATE: {
        ACTIVE: 'Активен',
        INACTIVE: 'Ваш ключ деактивирован',
        NEW: 'Новый ключ ',
      },
      CATEGORIES: {
        QR: 'Генерация QR',
        QR_DATA_REQUEST: 'Запрос данных по QR-платежу',
        OUTLET: 'Список точек продаж и касс',
        POS_OPERATION_STATEMENT: 'Выписка по POS и QR - платежам',
        QR_OPERATION_STATEMENT: 'Выписка по QR - платежам',
      },
      KEY_COPY: 'Скопируйте и сохраните ключ',
      KEY_COPIED: 'Ключ скопирован и сохранён',
      CHOOSE_CATEGORY: 'Выберите категорию',
      VALID_UNTIL: 'Конец активности',
      CATEGORY: 'Категория',
    },
    TOTP_CONTAIN_SIX_DIGITS: 'TOTP-код должен содержать 6 цифр',
    SET: 'Установить',
  },
  CHECK_TYPES: {
    UPP_LOW_CASE_LATIN: 'большие и маленькие латинские буквы',
    NUMBERS: 'цифры',
    SYMBOLS: "символы {'.!@#$%^&*-'}",
    BETWEEN_CHARACTERS: 'от 8 до 255 символов',
  },
  EXTRA_SETTINGS: {
    TITLE: 'Еще',
    SUBTITLE: 'Call center, Помощь',
    CATEGORIES: {
      PRODUCTS: 'ПРОДУКТЫ',
      MAIN: 'ОСНОВНЫЕ',
      COMMUNICATION: 'СВЯЗАТЬСЯ С БАНКОМ',
    },
    NAV: {
      FAQ: {
        TITLE: 'Помощь',
        DESCRIPTION: 'Частые вопросы и ответы на них',
        USER_GUIDE: 'Руководство пользователя',
      },
      CALL_CENTER: {
        TITLE: 'Call center',
        DESCRIPTION: '7711 бесплатно',
      },
    },
  },
  MORE: {
    TITLE: 'Ещё',
    SUB_TITLE: 'Связаться с банком',
  },
  ACCOUNT: {
    TITLE: 'Мои счета',
    STATUS_TITTLE: {
      OPEN: 'Открыт',
      CLOSED: 'Закрыт',
      ARRESTED: 'Арестован',
      FINAL_ARRESTED: 'Заблокирована',
    },
    CURRENT: 'Текущий счет',
    EMPTY: 'Нет доступных счетов',
    EMPTY_BY_ACCESS: 'У вас нет разрешения на совершение платежей, обратитесь к руководству {company_name}',
    MULTI_CURRENCY_REQUIRED:
      'Для выполнения этой операции требуется мультивалютный счёт. Открыть его можно в отделении банка',
    SEVERAL_ACCOUNTS_REQUIRED:
      'Для перевода между счетами у вас должно быть открыто несколько расчётных счетов. Открыть дополнительный счёт можно в отделении банка.',
    ERROR: 'Не удалось получить счета',
    AVAILABLE_BALANCE_DETAILS: {
      TITLE: 'Подробная информация по счёту',
      ACTUAL: 'Фактический остаток',
      PENDING_TOTAL: 'Общая сумма платежей на подписании и в обработке:',
      PAYMENT_COUNT: 'нет платежей | {n} платеж | {n} платежа | {n} платежей',
      SIGNING_LABEL: 'На подписании:',
      SIGNING_LABEL_MOBILE: 'На подписании в Optima Business:',
      PROCESSING_LABEL: 'В обработке:',
      AVAILABLE: 'Доступный остаток',
    },
  },
  DOCUMENTS: {
    TITLE: 'Документы',
    REQUISITES: {
      NAV: 'Реквизиты',
      FILES: {
        FILE_ONE: {
          TITLE: 'Реквизиты для зачисления межбанковского входящего перевода',
          DOWNLOAD: 'Скачать',
          SHARE: 'Поделиться',
        },
      },
      DOWNLOADING: 'Файл скачивается',
      ERROR: 'Не удалось скачать реквизиты',
    },
    STATEMENT_ACCOUNT: {
      TITLE: 'Выписки',
      NAV: 'Выписки',
      DOWNLOAD_PDF: 'Скачать файл PDF',
      DOWNLOAD_XLSX: 'Скачать файл Excel',
      DOWNLOADING: 'Файл скачивается',
      ORDER_FORMED: 'Заказ формируется',
      ORDER: {
        EXTRACT: 'Сформировать выписку',
        OPTIONS: 'Параметры для выписки',
        VIEW: 'Представление',
        WITHOUT_QR_DETAILS: 'Без детализации QR-операций',
        WITH_QR_DETAILS: 'C детализацией QR-операций',
        MULTIPLE_CURRENCY: 'Можно выбрать несколько валют',
        DATE_FROM: 'Дата от',
        DATE_TO: 'Дата до',
        PERIOD_FILTER: {
          TITLE: 'Фильтр по периоду',
          BY_REIMBURSEMENT: 'По возмещению на счет',
          BY_TRANSACTION_DATE: 'По дате транзакции',
          REIMBURSEMENT_DESCRIPTION: 'По возмещению — дата поступления денежных средств на расчетный счет или карту',
          TRANSACTION_DESCRIPTION: 'По дате транзакции — дата совершения платежа',
        },
      },
      STATUS: {
        IN_PROGRESS: 'В процессе',
        READY: 'Выписка сформирована',
        NOT_FOUND: 'Нет данных за период',
        FAIL: 'Не удалось сформировать',
        PENDING: 'В ожидании',
      },
      COLUMN_TABLE: {
        ACCOUNT: 'Номер счета',
        PERIOD: 'Период выписки',
        REQUEST_DATE: 'Дата заявки',
      },
      ALL_ACCOUNT: 'По всем счетам',
      EMPTY: 'У вас нет сформированных выписок.\nНажмите «Сформировать выписку», чтобы создать.',
      HAS_NOT_POS: 'У вас нет сформированных выписок.\n' + 'Нажмите «Сформировать выписку», чтобы создать.',
      ERROR: 'Не удалось получить выписки',
      ORDER_EXTRACT: {
        IN_PROCESSING: 'Запрос на формирование выписки принят в обработку',
        FAIL: 'Не удалось сформировать выписку',
      },
      OUTLET: {
        SELECT_ALL_OUTLET: 'Все точки продаж',
        SELECT_ALL_POS: 'Все POS-терминалы',
        SELECT_ALL_POS_AND_KIOSKS: 'Все POS + киоски',
        POS_NUMBER: 'Номер POS-терминала',
      },
      RANGE_DATE: {
        TODAY: 'Сегодня',
        YESTERDAY: 'Вчера',
        WEEK: 'Неделя',
        MONTH: 'Месяц',
      },
    },
    DEVICE_STATEMENTS: {
      NAV: 'Выписки по устройствам',
      DEVICE_NAME: 'Наименование ТСП',
      POS_NUMBER: 'Номер устройства (POS)',
    },
  },
  EMPLOYEES: {
    TITLE: 'Сотрудники',
    SALARY: {
      SAVED_SUCCESSFULLY: 'Настройка роли изменена',
    },
    DETAILS: {
      ACCOUNT_SETTINGS: 'Настройки счетов',
      EMPLOYEE: 'Сотрудник:',
      ROLE: 'Роль:',
      ACCOUNT_NUMBER: 'Номер счета',
      TREATY: 'Договор',
      ACCOUNTS: {
        TITLE: 'Счета',
        SAVED_SUCCESSFULLY: 'Настройка счета изменена',
        ACCOUNTS_EMPTY: 'Нет',
      },
      POINT_ACCESS: {
        TITLE: 'Доступ к точкам',
        SUBTITLE: 'Открывайте доступ к точкам',
        ENABLE_ALL: 'Включить все точки',
        SEARCH_PLACEHOLDER: 'Название торговой точки',
      },
    },
    LIST: {
      FULL_NAME: 'ФИО',
      PHONE_NUMBER: 'Номер телефона',
      ROLE: 'Роль',
      DATE_OF_REGISTRATION: 'Дата регистрации',
      MISSING_EMPLOYEES: 'Отсутствуют сотрудники',
    },
    STATUS: {
      ACTIVE: 'Активен',
      FREEZE: 'Блокирован',
    },
    ROLE: {
      CREATOR: 'Исполнитель',
      FIRST: 'Право первой подписи',
      SECOND: 'Право второй подписи',
      AUDITOR: 'Аудитор',
      NONE: 'Без подписи',
      CASH_MANAGER: 'Менеджер',
      CASHIER: 'Кассир',
    },
    SETTINGS: {
      ERROR: 'Не удалось получить список сотрудников',
    },
  },
  IMPORTED: {
    TITLE: 'Импортированные',
    FILE_NAME: 'Название файла',
    DATE_DOWNLOAD: 'Дата загрузки',
    CREATE_OPERATION: 'Создать операции',
    RETRY_UPLOAD: 'Повторить загрузку файла',
    FAILED_IMPORTED: 'Не удалось получить импортированные файлы',
    GO_OPERATION: 'Перейти в операцию',
    CAUSE: 'Причина',
    PAYMENT_PROCESSING: 'Обработка платежей',
    STATUS_FILE: {
      PROCESSED: 'Обработан',
      REJECTED: 'Отклонен',
      ERROR_PROCESSING: 'Ошибка при обработке',
      PREPARING: 'Формирование...',
      PAYMENT: {
        PROCESSING: 'В обработке',
        UNPROCESSABLE: 'Проверьте содержимое файла',
        FAILED: 'Ошибка при создании операции',
        DENIED: 'Отказано в создании операции',
        UPLOADING: 'Создание операций...',
        UPLOADED: 'Операции созданы',
        EDITED: 'Данная операция была отредактирована',
        ERROR_UPLOADING: 'Ошибка при создании операции',
        PARTIALLY_PROCESSED: 'Обработан частично',

        FILE_VALIDATION_PROCESSING: 'Проверяем ведомость...',
        FILE_VALIDATION_FINISHED: 'Ведомость в порядке',
        FILE_VALIDATION_ERROR: 'Проверьте данные',
        BUSINESS_VALIDATION_PROCESSING: 'Проверяем реквизиты...',
        BUSINESS_VALIDATION_FINISHED: 'Реквизиты в порядке',
        BUSINESS_VALIDATION_ERROR: 'Проверьте счета списания и зачисления',
        SALARY_CREATION_PROCESSING: 'Создаём ведомость...',
        SALARY_CREATION_FINISHED: 'Создали ведомость и платёж',
        SALARY_CREATION_ERROR: 'Что-то пошло не так. Попробуйте ещё раз',
        ERROR_CONFIRMED: 'В архиве',
        PROCESSING_COMPLETED: 'Готова к подписанию',
      },
      SALARY: {
        PROCESSING: 'На обработке',
        UNPROCESSABLE: 'Не получается обработать платежи',
        FAILED_PREPARING: 'Неудачная попытка при формировании',
        ERROR_PREPARING: 'Ошибка при формировании',
        READY_FOR_EXECUTION: 'Готов к исполнению',
      },
    },
    STATUS_PAYMENT: {
      OK: 'Обработан',
      REJECTED: 'Отклонен',
    },
    EMPTY: 'Отсутствуют файлы',
    CHOOSE_FILE_TYPE: {
      TITLE: 'Выберите желаемый тип',
      LABEL: 'Пожалуйста, выберите тип для межбанковских переводов с суммой ниже или равной 1 миллиону сомов',
    },
    WARNING: '*переводы с суммой выше 1 миллиона сомов автоматически отправляются типом Гросс',
  },

  PAYMENT: {
    TITLE: 'Платеж',
    FOR_SIGN: 'Платежи на подпись',
    NO_ACCESS_OPERATION: {
      TITLE: 'Не нашли нужный счет?',
      DESCRIPTION: 'У вас нет к нему доступа. Попросите 1-го Подписанта выдать вам права.',
      MANAGER_HINT: 'Как руководителю выдать доступ:',
      STEPS:
        'Настройки → Сотрудники → Выбрать нужного сотрудника → Выбрать нужный счет → Включить тумблер нужной операции',
    },
    TYPE: {
      CLEARING: 'Клиринг',
      GROSS: 'Гросс',
      CLEARING_GROSS: 'Клиринг/Гросс',
      SWIFT: 'SWIFT',
      INTRABANK_TRANSFER_OWN: 'Перевод между своими счетами',
      INTRABANK_TRANSFER_FOREIGN: 'Перевод на другие клиентские счета',
      INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Перевод на Бизнес карту',
      RKO_2_BUSINESS_CARD_OWN: 'Перевод на Бизнес карту',
      RKO_2_BUSINESS_CARD_FOREIGN: 'Перевод на Оптима24',
      RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Перевод на Оптима24',
      RKO_2_INDIVIDUAL_CARD_OWN: 'Перевод на Оптима24',
      BUSINESS_CARD_2_RKO_OWN: 'Перевод с Бизнес карты на расчетный счет',
      BUSINESS_CARD_2_RKO_FOREIGN: 'Перевод с Бизнес карты на расчетный счет',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_OWN: 'Перевод с Бизнес карты на свои расчетные счета',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_FOREIGN: 'Перевод с Бизнес карты на другие расчетные счета',
      CONVERSION: 'Конвертация',
      BUDGET_PAYMENT: 'Бюджетный платеж',
      REFUND: 'Возврат QR-платежа',
      QR: 'Платеж/перевод по QR',
      TRANSFER_BY_INVOICE: 'Оплата счета на оплату',
      NO_TITLE: 'Без наименования',
      BETWEEN_ACCOUNTS: 'Между своими счетами',
      INTRABANK_TRANSFER: 'Внутрибанк. перевод',
      VIEW_ACCOUNT: 'Просмотр счета',
      VIEW_LOAN_CLAIM: 'Просмотр информации по кредиту',
      SALARY: 'Зарплатный проект',
    },
    ORIGIN: {
      ALL: 'Все',
      MANUAL: 'Пользовательский',
      DIRECT_BANK: '1C',
      FILE: 'Импортированный',
    },
    NOTIFICATIONS: {
      MESSAGE: {
        ERROR: {
          TITLE: 'Платеж <span class="text-primary">Отказан Банком</span>',
          TITLE_TEXT: 'Платеж Отказан Банком',
          TEXT: '"{operationCode}" №{transferNum} сумма {amount} {currency}',
        },
        PAYMENT_REQUEST_TO_BANK: {
          TITLE: 'Платеж <span class="text-primary">Отказан Банком</span>',
          TITLE_TEXT: 'Платеж Отказан Банком',
          TEXT: '"{operationCode}" №{transferNum} сумма {amount} {currency} \n( {text} )',
        },
      },
    },
    TEMPLATES: {
      TITLE: 'Шаблоны',
      NAME: 'Название шаблона',
      SEARCH: 'Поиск шаблонов',
      CREATED: 'Шаблон сохранен',
      EDIT: 'Редактировать шаблон',
      EDITING: 'Редактирование шаблона',
      EDITED: {
        SUCCESS: 'Шаблон отредактирован',
        ERROR: 'Не удалось отредактировать шаблон',
      },
      DELETE: 'Удалить шаблон',
      DELETED: 'Шаблон удален',
      NOT_FOUND: 'Шаблоны не найдены',
      CREATE: 'Создание шаблона',
    },
    DIALOG: {
      EXIT: {
        TITLE: 'Вы действительно хотите выйти из процесса оплаты?',
        LABEL: 'Если вы выйдете сейчас, все введенные данные могут быть потеряны.',
      },
    },
  },
  STATEMENT: {
    TRANSACTION: {
      DATE: {
        TODAY: 'Сегодня',
        TODAY_TIME: 'Сегодня в {time}',
        YESTERDAY: 'Вчера',
        YESTERDAY_TIME: 'Вчера в {time}',
      },
      EMPTY: {
        SUCCESS: 'Нет завершенных операций',
        ON_SIGN: 'Нет операций для подписания',
        REJECTED: 'Нет отклоненных операций',
        ERROR: 'Нет операций, отклоненных Банком',
        FOR_EDITING: 'Нет операций для редактирования',
        DRAFT: 'Ваш список черновиков пуст',
      },
      EMPTY_STATEMENT: 'Список операций пуст',
      DELETE: 'Удалить',
      DOWNLOAD: 'Скачать в PDF',
      DOWNLOAD_STATEMENT: 'Скачать выписку',
      SCHEME: 'Показать схему',
      GET: 'Скачать',
      OPEN: 'Открыть',
      EDIT: 'На редактирование',
      EDIT_ALL: 'Все на редактирование',
      CHANGE: 'Отредактировать',
      REPEAT: 'Повторить',
      REVOKE: 'Отклонить',
      REVOKE_ALL: 'Отклонить все',
      SIGN: 'Подписать платеж',
      SIGN_ALL: 'Подписать все',
      SEND_FOR_SIGN: 'Отправить на подпись',
      SEND_AFTER_CHANGE: 'Направить на подпись',
      RECALL: 'Отозвать',
      PRINT: 'Распечатать',
    },
    TRANSFER_ACTIONS: {
      DELETE: 'Удалить',
      EDIT: 'Редактировать платеж',
      EDITING: 'Редактирование платежа',
      CHANGE: 'Отредактировать',
      REPEAT: 'Повторить',
      REVOKE: 'Отклонить',
      SIGN: 'Подписать',
      TITLE: 'Детали платежа',
      FOR_SIGN: 'На подпись',
      RECALL: 'Отозвать платеж',
    },
    NOTIFICATIONS: {
      TITLE: 'Выписка',
      TITLE_MANY: 'Выписки',
      OK: 'Ок',
      GO_ON: 'Перейти',
      MESSAGE: {
        READY: 'Выписка сформирована',
        FAIL: 'Не удалось сформировать',
        NOT_FOUND: 'Нет данных для выписки за указанный период',
        MANY_STATEMENT: 'Заявки сформированы',
      },
    },
    DIALOG: {
      FAIL: 'Не удалось сформировать выписку',
    },
  },
  EXCHANGE_RATES: {
    ALL_RATES: 'Все курсы',
    PURCHASE: 'Покупка',
    SALE: 'Продажа',
    FOR: 'на',
    RATES_LOADING_ERROR: 'Курсы валют не загрузились. Попробуйте обновить раздел',
    CASH: 'Наличные курсы',
    CASHLESS: 'Безналичные курсы',
    CARD: 'Курсы по картам',
    NBKR: 'Курсы НБКР',
    RATES: 'Курсы валют',
    ALL_EXCHANGE_RATES: 'Все курсы валют',
  },
  SIGNATORIES: {
    MANY_SIGNATORY: 'Подписанты',
    PRIMARY_SIGNATURE: 'Первая подпись',
    SECONDARY_SIGNATURE: 'Вторая подпись',
    PROCESSING_SIGNATURE: 'В ожидании подписи',
    ON_VERIFICATION_COMPLETED: 'Подписан',
    PARTIAL_CONFIRMATION_COMPLETED: 'Подписан',
    CANCELED_SIGN_ONE: 'Отказан',
    CANCELED_SIGN_TWO: 'Отказан',
    FOR_EDITING: 'Отказан',
    REVOKE: 'Отозван',
    ON_CONFIRMATION_COMPLETED: 'Отправлен в Банк',
  },
  FILTER_HISTORY: {
    FILTER: 'Фильтр',
    SEARCH: 'Искать',
    PURPOSE: 'Назначение платежа',
    PAYMENT_TYPE: 'Тип платежа',
    PAYMENT_ORIGIN: 'Происхождение',
    DATE_FROM: 'Дата от',
    DATE_TO: 'Дата до',
    AMOUNT_FROM: 'Сумма от',
    AMOUNT_TO: 'Сумма до',
    APPLY: 'Применить',
    RESET: 'Сбросить',
    WITH: 'c {value}',
    BEFORE: 'до {value}',
    RULE_AMOUNT: 'Начальная сумма не может превышать конечную!',
    RULE_THREE_MONTH_PERIOD: 'Укажите не более 3-х месяцев',
    ASCENDING: 'По возрастанию',
    DESCENDING: 'По убыванию',
    BY_DEADLINE: 'По сроку',
    BY_TOTAL: 'По сумме',
    BY_QR_TYPE: 'По типу QR',
    BY_QR_TRANSACTION_TYPE: 'По типу транзакции',
  },
  NOTIFICATION: {
    READ_ALL: 'Прочитано все',
    TITLE: 'Уведомления',
    EMPTY: 'У вас еще нет уведомлений',
  },
  RECAPTCHA: {
    TEXT: 'Этот сайт защищен reCAPTCHA и Google',
    AND: 'и',
    PRIVACY_POLICY: 'Политикой конфиденциальности',
    TERMS_OF_SERVICE: 'Условиями предоставления услуг',
  },
  ERRORS: {
    AUTH: {
      OTP_INCORRECT: 'TOTP-код не верный',
      PERMANENT_LOCKOUT_EXCEPTION: 'Пользователь заблокирован!',
      USER_CREDENTIALS_EXCEPTION: 'Неверный ID клиента или пароль',
      PHONE_ALREADY_EXISTS: 'Некорректный номер телефона',
      USER_STATE_INCORRECT: 'Вы не прошли первичную регистрацию. Сброс пароля не возможен.',
      UNKNOWN: 'Ошибка. Пожалуйста, попробуйте позже.',
    },
    PAYMENT: {
      SWIFT_RSBANK_EXCEPTION:
        'Перевод на выбранный банк невозможен в связи с внутренней политикой банка корреспондента.',
      ACCOUNT_DEBIT_NOT_FOUND: 'Не найден счет для списания.',
      ACCOUNT_CREDIT_NOT_FOUND: 'Не найден счет получателя.',
      OPERATION_NOT_ALLOWED: 'Операция такого типа запрещена!',
      ACCOUNT_NOT_ACCESSIBLE: 'Данный счет вам недоступен!',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED: 'Счет списания закрыт или арестован.',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED: 'Счет получателя закрыт или арестован.',
      INVALID_OPERATION_TYPE: 'Невозможно сделать такого типа операцию по данному счету.',
      INSUFFICIENT_FUNDS: 'Недостаточно средств на счете.',
      CURRENCY_MISMATCH_FOR_CONVERSION: 'Для совершения Конвертации требуется выбрать счета с разными валютами.',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT: 'Невозможно использовать такой тип платежа на внутрибанковский счет.',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS: 'Валюта счета списания не совпадает с валютой счета получателя.',
      INVALID_OPERATION_FOR_YOUR_COMPANY: 'Для перевода на счет Вашего юр. лица выберите другой тип операции.',
      INVALID_OPERATION_FOR_OTHER_COMPANY: 'Для перевода на счет другого юр. лица выберите другой тип операции.',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY: 'Счет не относится к юр. лицу.',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE: 'Сотрудник заблокирован или не относится к Компании.',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY: 'Данный тип операции не доступен в ин. валюте.',
      INVALID_REQUISITE_EXCEPTION: 'Переводы на Элкарт по номеру карточного счета недоступны',
      INVALID_CARD_TYPE_CODE_EXCEPTION: 'Переводы на карты Элкарт Бизнес недоступны',
      CHECK_RU_CITIZEN_EXCEPTION: 'Согласно ограничениям банка-корреспондента, переводы в евро недоступны',
      INVOICE_NOT_FOUND: 'Счёт на оплату не найден',
      WRONG_INVOICE_TYPE: 'Счёт имеет недопустимый тип',
      WRONG_INVOICE_STATE: 'Счёт нельзя изменить в текущем статусе',
      INVOICE_IS_PAID: 'Счёт уже оплачен. Отмена невозможна',
      CLIENT_NOT_FOUND: 'Клиент не найден',
      RECIPIENT_NOT_FOUND: 'Не найден отправитель или номер счета',
      PAYER_EXCEPTION: 'Плательщик и получатель не могут совпадать',
      PAYER_NOT_EMPTY_EXCEPTION: 'Для внешнего счёта плательщик не указывается',
      ELQR_NOT_CREATED: 'Не удалось сгенерировать QR',
      WRONG_DETAIL_AMOUNT: 'Стоимость товара не соответствует цене и количеству',
      WRONG_AMOUNT: 'Общая сумма счёта не соответствует сумме товаров',
      ALREADY_EXISTS_EXCEPTION: 'Товар / услуга с таким наименованием уже существует',
      OPERATION_NOT_VALID_EXCEPTION: 'По этому счёту на оплату уже есть платёж',
      INVALID_INVOICE_STATE: 'Нельзя создать платёж для счёта на оплату в текущем статусе',

      CHECK_FIELD_FOR_NULL_EXCEPTION: 'Отсутствуют некоторые данные в платеже, проверьте файл.',
      FILE_NOT_FOUND_EXCEPTION: 'Отсутствует данный файл.',
      FILE_PREPARE_TO_CREATE_EXCEPTION: 'Ошибка при подготовке к созданию.',
      FILE_REPEAT_EXCEPTION:
        "Ошибка при повторении обработки: повторить можно файлы со статусом 'Ошибка при обработке'.",
      FILE_STATE_MISMATCH_EXCEPTION:
        "Ошибка при создании платежей: создать платежи можно только с файла со статусами: 'Обработан', 'Неудачный', 'Ошибка при загрузке'.",
      FILE_SIZE_EXCEPTION: 'Размер файла превышает допустимое значение.',
      FILE_EXTENSION_EXCEPTION: 'Расширение файла не соответствует ожидаемому.',
      DUPLICATE_PAYMENT_IN_IMPORTED_FILE_EXCEPTION: 'Дублируются платежи в файле: проверьте/измените данные.',
      CANT_DETERMINE_ORGANIZATION_EXCEPTION: 'Ошибка, требуется обратиться в отделение банка.',
      DOCUMENT_NUMBER_ALREADY_EXISTS_EXCEPTION:
        'Текущий номер платёжного поручения уже использован, просьба использовать уникальный номер.',
      FORBIDDEN_EXCEPTION: 'Ошибка, доступ запрещен.',
      NOT_ALLOWED_DELETE_OPERATION: 'Удаление невозможно, требуется сформировать письмо в банк.',
      PROCESS_ALREADY_EXISTS_EXCEPTION: 'Ошибка. Данная операция в процессе обработки.',
      RULE_EXCEPTION: 'Ошибка. Пожалуйста, проверьте корректность вводимых данных.',
      ACTIVITI_PROCESS_ALREADY_EXISTS_EXCEPTION: 'Ошибка, платёж уже существует.',
      INTRA_AND_INTER_BANK_BIC_CORRESPONDENCE_EXCEPTION:
        'Несоответствие БИК и счетов. (если это зачисление на транзитный счет, убедитесь что ваш и транзитный счет из одного подразделения)',
      INTERBANK_INVALID_CURRENCY_EXCEPTION: 'Недопустимая валюта для Клиринг/Гросс.',
      INTERBANK_SAME_BIC_CODES_EXCEPTION: 'Недопустимый БИК для Клиринг/Гросс.',
      INTRA_AND_INTERBANK_BBAN_ACCOUNT_STRUCTURE_EXCEPTION: 'Ошибка, структура счета получателя не соответствует BBAN.',
      INTRA_AND_INTERBANK_SAME_ACCOUNT_EXCEPTION: 'Ошибка, счёт отправителя и получателя должны отличаться.',
      INTRABANK_DIFFERENT_BIC_CODES_EXCEPTION: 'Недопустимый БИК для внутрибанковского платежа.',
      INVALID_VALUE_DATE_EXCEPTION: 'Ошибка, нельзя выбирать прошедшие даты.',
      NOT_WORKING_DAY_FOR_VALUE_DATE_EXCEPTION: 'Ошибка, выбранная дата валютирования является нерабочим днём.',
      SWIFT_INVALID_EXOTIC_CURRENCY_EXCEPTION: 'Недопустимая валюта для СВИФТ в экзотической валюте.',
      FILE_READING_EXCEPTION: 'Ошибка при прочтении файла. Содержимое файла не соответствует ожидаемому.',

      INVALID_PAYER_BANK_EXCEPTION: 'Не найден БИК банка плательщика.',
      INVALID_RECIPIENT_BANK_EXCEPTION: 'Не найден БИК банка получателя.',
      INVALID_PAYMENT_CODE_EXCEPTION: 'Не найден код платежа.',
      LEGAL_PARTY_ID_CANT_BE_NULL_EXCEPTION: 'Отсутствует ID Компании.',
      PAYER_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует счет списания.',
      PAYER_BIC_CANT_BE_NULL_EXCEPTION: 'Отсутствует БИК плательщика.',
      PAYER_NAME_CANT_BE_NULL_EXCEPTION: 'Отсутствует наименование плательщика.',
      PAYER_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует сумма списания.',
      PAYER_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Отсутствуют данные о валюте списания.',
      RECIPIENT_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует счет зачисления.',
      RECIPIENT_BIC_CANT_BE_NULL_EXCEPTION: 'Отсутствует БИК получателя.',
      RECIPIENT_NAME_CANT_BE_NULL_EXCEPTION: 'Отсутствует наименование получателя.',
      RECIPIENT_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует сумма зачисления.',
      RECIPIENT_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Отсутствует валюта зачисления.',
      AMOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует сумма платежа.',
      CURRENCY_CANT_BE_NULL_EXCEPTION: 'Отсутствует валюта платежа.',
      PURPOSE_CANT_BE_NULL_EXCEPTION: 'Отсутствует назначение платежа.',
      COMMISSION_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствует счет для оплаты комиссии.',
      COMMISSION_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Отсутствует валюта счета комиссии.',
      COMMISSION_OPTION_CANT_BE_NULL_EXCEPTION: 'Отсутствуют данные о тарификации.',
      IS_EXOTIC_CANT_BE_NULL_EXCEPTION: 'Отсутствуют данные о сумме экзотики.',
      EXOTIC_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Отсутствуют данные о сумме экзотики.',
      EXOTIC_RATE_CANT_BE_NULL_EXCEPTION: 'Отсутствуют данные о курсе экзотики.',
      EXOTIC_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Отсутствует экзотическая валюта.',
      RUB_CODE_VO_CANT_BE_NULL_EXCEPTION: 'Отсутствует Код VO.',
      RUB_INN_CANT_BE_NULL_EXCEPTION: 'Отсутствует ИНН (руб).',
      KZT_BIN_CANT_BE_NULL_EXCEPTION: 'Отсутствует БИН.',
      KPP_CANT_BE_NULL_EXCEPTION: 'Отсутствует КПП.',
      VALUE_DATE_CANT_BE_NULL_EXCEPTION: 'Отсутствует дата валютирования.',
      OPERATION_CANT_BE_NULL_EXCEPTION: 'Отсутствует операция.',
      PAYER_INN_CANT_BE_NULL_EXCEPTION: 'Отсутствует ИНН плательщика.',
      PAYMENT_CODE_CANT_BE_NULL_EXCEPTION: 'Отсутствует Код оплаты.',
      RUB_CODE_VO_MUST_BE_NULL_EXCEPTION: 'Код VO должен отсутствовать.',
      RUB_INN_MUST_BE_NULL_EXCEPTION: 'ИНН (руб) должен отсутствовать.',
      KZT_BIN_MUST_BE_NULL_EXCEPTION: 'БИН должен отсутствовать.',
      KPP_MUST_BE_NULL_EXCEPTION: 'КПП должен отсутствовать.',
      EXOTIC_AMOUNT_MUST_BE_NULL_EXCEPTION: 'Сумма экзотики должна отсутствовать.',
      EXOTIC_RATE_MUST_BE_NULL_EXCEPTION: 'Курс экзотики должен отсутствовать.',
      EXOTIC_CURRENCY_MUST_BE_NULL_EXCEPTION: 'Экзотическая валюта должна отсутствовать.',
      INSUFFICIENT_FUNDS_EXCEPTION: 'Сумма платежа превышает доступный баланс счета',

      CELL_VALUE_DATE_IS_EMPTY: 'Укажите дату в соответствующей ячейке.',
      CELL_VALUE_DATE_DATA_IS_INVALID_WORKING_DAY: 'Дата валютирования не может быть выходным днем.',
      CELL_VALUE_DATE_DATA_IS_INVALID_TIME: 'Допустимое время уже вышло, попробуйте в другой день.',
      CELL_VALUE_DATE_DATA_IS_INVALID_DATE: 'Дата валютирования может быть только текущей.',
      CELL_LEGAL_PARTY_ID_IS_EMPTY: 'Заполните поле "ID Компании".',
      CELL_COMPANY_NAME_IS_EMPTY: 'Заполните поле "Наименование Компании".',
      CELL_ACCOUNT_IS_EMPTY: 'Пожалуйста,  заполните поле транзитный счет в соответствующей ячейке.',
      CELL_AMOUNT_IS_EMPTY: 'Пустое поле "Общая сумма".',
      CELL_COMMISSION_IS_EMPTY: 'Заполните поле "Комиссия банка".',
      CELL_TOTAL_AMOUNT_IS_EMPTY: 'Пустое поле "Итоговая сумма".',
      CELL_CURRENCY_IS_EMPTY: 'Заполните поле "Валюта".',
      CELL_FORMULA_TOTAL_AMOUNT_IS_EMPTY: 'Пустое поле "Рассчитаная сумма".',
      DETAILS_CELL_CARD_ACCOUNT_IS_EMPTY: 'Заполните поле "Счет сотрудника".',
      DETAILS_CELL_AMOUNT_IS_EMPTY: 'Пожалуйста, заполните поле суммы зачисления сотруднику в соответствующей ячейке.',
      DETAILS_CELL_EMPLOYEE_NAME_IS_EMPTY: 'Заполните поле "ФИО сотрудника".',
      CELL_VALUE_DATE_INVALID_FORMAT: 'Обязательный формат ячейки с информацией о дате - "Краткий формат даты".',
      CELL_LEGAL_PARTY_ID_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией об ID компании - "Общий/Текстовый".',
      CELL_COMPANY_NAME_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о наименовании компании - "Общий/Текстовый".',
      CELL_ACCOUNT_INVALID_FORMAT: 'Обязательный формат ячейки с информацией о  счете - "Общий/Текстовый".',
      CELL_AMOUNT_INVALID_FORMAT: 'Обязательный формат ячейки с информацией об общей сумме - "Общий/Числовой".',
      CELL_COMMISSION_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о комиссии банка - "Общий/Числовой". Максимальное количество чисел в дробной части сумм в файле ведомости равно 2шт.',
      CELL_TOTAL_AMOUNT_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией об итоговой сумме - "Общий/Числовой".',
      CELL_CURRENCY_INVALID_FORMAT: 'Обязательный формат ячейки с информацией о валюте - "Общий/Текстовый".',
      CELL_FORMULA_TOTAL_AMOUNT_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о рассчитаной сумме - "Общий/Числовой".',
      DETAILS_CELL_CARD_ACCOUNT_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о счете сотрудника - "Общий/Текстовый".',
      DETAILS_CELL_AMOUNT_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о сумме зачисления сотруднику - "Общий/Числовой". Максимальное количество чисел в дробной части сумм в файле ведомости равно 2шт.',
      DETAILS_CELL_EMPLOYEE_NAME_INVALID_FORMAT:
        'Обязательный формат ячейки с информацией о ФИО сотрудника - "Общий/Текстовый".',
      CELL_VALUE_DATE_DATA_IS_INVALID: 'Дата валютирования может быть только текущей.',
      CELL_ACCOUNT_DATA_IS_INVALID: 'Обязательный формат расчетного счета списания: 16 цифр, 109#############',
      CELL_CURRENCY_DATA_IS_INVALID: 'Допустимая валюта: KGS/USD',
      DETAILS_CELL_CARD_ACCOUNT_DATA_IS_INVALID:
        'Обязательный формат карточного счета сотрудника: 16 цифр, 109#############',
      DETAILS_CELL_AMOUNT_DATA_IS_INVALID: 'Сумма зачисления сотруднику не может принимать отрицательное значение.',
      DETAILS_LIST_IS_EMPTY: 'Список сотрудников отсутствует.',
      INVALID_SALARY_TOTAL_AMOUNT_SUM:
        'Не совпадают «Сумма зачисления на карт-счета» и рассчитанная сумма со списка сотрудников на зачисления.',
      INVALID_SALARY_AMOUNT_COMPARISON: 'Не совпадают «Сумма зачисления на карт-счета» и «Рассчитанная сумма».',
      INVALID_SALARY_TOTAL_AMOUNT_CALCULATION:
        'Неверно рассчитана итоговая сумма с учетом комиссии (используйте формулу из шаблона).',
      SALARY_DETAIL_DUPLICATE_EXCEPTION: 'Обнаружен дублированный счет у сотрудников.',
      //FORBIDDEN_EXCEPTION: 'Ведомость не принадлежит к текущей организации.',
      SALARY_DUPLICATE_EXCEPTION: 'Текущее название файла уже использовано.',
      ERROR: 'Произошла ошибка при обработке зарплатной ведомости. Попробуйте еще раз.',
      SUCCESS: 'Файл успешно загружен.',
      ACCOUNT_ERROR: 'Счет не найден.',
      CURRENCY_ERROR: 'Счет с выбранной валютой не найден. Проверьте и попробуйте еще раз.',
      SUM_ERROR: 'Причина: итоговая сумма неправильная.',
      CONTRACT_NOT_FOUND_ERROR: 'Контракт не найден.',
      OPERATION_DATE_ERROR: 'Причина: связанная с датой операционный день закончился.',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'На счету недостаточно средств',
      ACCOUNT_DIFF_ERROR: 'Счёт организации отличается от счёта в ведомости.',
      EMPLOYEE_ACCOUNT_ERROR: 'Счёта сотрудника не существует.',
      EMPLOYEE_CURRENCY_ERROR: 'Валюта на счете сотрудника не соответствует записи в ведомости.',
      FULL_NAME_ERROR: 'ФИО сотрудника в ведомости отличается от ФИО в системе.',
      EMPLOYEE_NOT_FOUND: 'Сотрудник не найден в контракте',

      EMPLOYEE_STATE_ERROR: 'Cтатус сотрудника некорректный. Обратитесь в филиал.',
      EMPLOYEE_CARD_STATE_BLOCKED: 'Карточный счет сотрудника заблокирован. Обратитесь в филиал.',
      EMPLOYEE_CARD_STATE_CLOSED: 'Карточный счет сотрудника закрыт. Обратитесь в филиал.',
      EMPLOYEE_CARD_STATE_ERROR: 'Проблемы с карточным счетом сотрудника. Обратитесь в филиал.',

      CELL_LEGAL_PARTY_ID_DATA_IS_INVALID:
        'Ошибка: Неверный код компании. Пожалуйста, убедитесь, что введённый идентификатор компании корректен и повторите попытку.',
      CLEARING_CREATION_DEADLINE_EXCEPTION:
        'Время создания Клиринга истекла. Пожалуйста, выберите другую дату валютирования.',
      CLEARING_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания Клиринга истекла. Пожалуйста, выберите другую дату валютирования.',
      GROSS_CREATION_DEADLINE_EXCEPTION:
        'Время создания Гросс переводов истекла. Пожалуйста, выберите другую дату валютирования.',
      GROSS_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания Гросс переводов истекла. Пожалуйста, выберите другую дату валютирования.',
      INTRA_OWN_CREATION_DEADLINE_EXCEPTION:
        'Время создания внутрибанковских переводов на свои счета истекла. Пожалуйста, выберите другую дату валютирования.',
      INTRA_OWN_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания внутрибанковских переводов на свои счета истекла. Пожалуйста, выберите другую дату валютирования.',
      INTRA_FOREIGN_CREATION_DEADLINE_EXCEPTION:
        'Время создания внутрибанковских переводов на чужие счета истекла. Пожалуйста, выберите другую дату валютирования.',
      INTRA_FOREIGN_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания внутрибанковских переводов на чужие счета истекла. Пожалуйста, выберите другую дату валютирования.',
      CONVERSION_CREATION_DEADLINE_EXCEPTION:
        'Время создания конвертации валют истекла. Пожалуйста, выберите другую дату валютирования.',
      CONVERSION_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания конвертации валют истекла. Пожалуйста, выберите другую дату валютирования.',
      SWIFT_CREATION_DEADLINE_EXCEPTION:
        'Время создания переводов по системе SWIFT истекла. Пожалуйста, выберите другую дату валютирования.',
      SWIFT_SIGNING_DEADLINE_EXCEPTION:
        'Время подписания переводов по системе SWIFT истекла. Пожалуйста, выберите другую дату валютирования.',
      SALARY_CREATION_DEADLINE_EXCEPTION:
        'Время создания выплаты заработной платы истекла. Пожалуйста, выберите другую дату валютирования.',
      SALARY_SIGNING_DEADLINE_EXCEPTION:
        'Время  подписания выплаты заработной платы истекла. Пожалуйста, выберите другую дату валютирования.',
      CREATION_DEADLINE_EXCEPTION: 'Время создания операции истекла. Пожалуйста, выберите другую дату валютирования.',
      SIGNING_DEADLINE_EXCEPTION: 'Время создания операции истекла. Пожалуйста, выберите другую дату валютирования.',

      ACCOUNT_CREDIT_NOT_FOUND_EXCEPTION: 'Не найден счет получателя в указанной валюте',
      OPERATION_NOT_ALLOWED_EXCEPTION: 'Операция выбранного типа запрещена для указанного счета',
      ACCOUNT_NOT_ACCESSIBLE_EXCEPTION: 'Доступ к просмотру счета запрещен',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED_EXCEPTION: 'Счет списания недоступен',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED_EXCEPTION: 'Счет пополнения недоступен',
      INVALID_OPERATION_TYPE_EXCEPTION: 'Невозможно сделать текущую операцию по выбраному счету!',
      CURRENCY_MISMATCH_FOR_CONVERSION_EXCEPTION: 'Для конвертации счета должны быть разно валютными!',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT_EXCEPTION: 'Невозможно в провести платеж на внутрибанковские счета',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS_EXCEPTION: 'Валюта счета списания не совпадает с валютой счета получателя',
      INVALID_OPERATION_FOR_YOUR_COMPANY_EXCEPTION: 'Счета принадлежат одному юр.лицу',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY_EXCEPTION: 'Счет получателя не относится к данному юр.лицу',
      INVALID_OPERATION_FOR_OTHER_COMPANY_EXCEPTION: 'Счет не относится к юр. лицу',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE_EXCEPTION: 'Не является сотрудником или заблокирован',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY_EXCEPTION: 'Операция по указанному счету в выбранной валюте невозможна',

      PACKAGE_TIME_OUT_EXCEPTION: 'Данный тип срока рассрочки не доступен, попробуйте создать QR - код под другой срок',
      PARTNER_DICTIONARY_EXCEPTION:
        'У вас нет необходимых прав для взаимодействия с данным продуктом. Для подключения к продукту свяжитесь с нами.',
      InstallmentForbiddenException:
        'У вас нет необходимых прав для просмотра и взаимодействия с данным разделом. Пожалуйста, обратитесь к ответственному лицу по предоставлению доступов в вашей компании для получения необходимых разрешений.',
      ACTIVITY_TIMEOUT_EXCEPTION: 'Не удалось найти активные параметры партнера или торговой точки, попробуйте еще раз',

      USER_HAS_ROLE_EXCEPTION: 'У пользователя, уже есть данная роль: ',
      USER_EXCEPTION: 'Учетная запись привязана к другому номеру телефона',
      EMPTY_PIN_EXCEPTION: 'ПИН/ИНН введен некорректно: ПИН/ИНН не может быть пустым',
      WRONG_FIRST_NUM_EXCEPTION: 'ПИН/ИНН введен некорректно: первое цифра должна начинаться с 1 или 2',
      WRONG_PIN_DATE_EXCEPTION: 'ПИН/ИНН введен некорректно: проверьте вводимые данные',
      WRONG_PIN_POSITION: 'ПИН/ИНН введен некорректно: цифра под 9 позицией не может состоять из 1 и 5',
      TASK_REJECTED_EXCEPTION:
        'Заявка на создание продавца рассрочки с ИНН, находится в обработке, пожалуйста дождитесь окончания заявки',
      PRODUCT_ROLE_POLICY_EXCEPTION: 'У пользователя отсутствуют роли для данной операции',
      NOT_FOUND_ROLE_EXCEPTION: 'К сожалению роль не найдена, попробуйте позже',
      DUPLICATE_TASK_EXCEPTION:
        'Заявка на создание продавца рассрочки с ИНН, находится в обработке, пожалуйста дождитесь окончания заявки',
      CONTRACT_NOT_STARTED_EXCEPTION:
        'Начало действия договора с партнером еще не наступило. Пожалуйста, дождитесь даты начала действия договора согласно заключенным условиям',
      ILLEGAL_ARGUMENT_EXCEPTION: 'Введен некорректный номер. Пожалуйста, проверьте и повторите ввод',
      LIMIT_BLOCKED_EXCEPTION: 'Перевести деньги можно только сотрудникам вашей компании',
      LIMIT_BLOCKED_EXCEPTION_WHITE_LIST: 'Отправить на подпись пока не получится — но функция скоро будет доступна',
      UNSUPPORTED_TYPE_OF_ACCOUNT_FOR_OPERATION_EXCEPTION:
        'Возвраты на Элкарт и счета до востребования пока недоступны',
      NOT_FOUND: '@:SHARED.RULE.CLIENT_NOT_FOUND',
      UNKNOWN: 'Ошибка! Пожалуйста, попробуйте позже!',
      KNOWN: 'Ошибка. Пожалуйста, попробуйте позже.',
    },

    OFFLINE: 'Отсутствует подключение к интернету',
    DOCUMENT_TEMPLATE: {
      FORBIDDEN_EXCEPTION: 'Доступ запрещен',
      LARGE_DOC_NOT_FOUND_EXCEPTION: 'Файл не найден',
      LARGE_DOC_ALREADY_EXISTS_EXCEPTION: 'Документ с указанными параметрами уже существует',
      LARGE_DOC_DOWNLOAD_NOT_ALLOWED_EXCEPTION: 'Невозможно скачать файл, так как он не имеет статус "Готово"',
      NOT_FOUND_QR_PAYMENT: 'Нет данных за выбранный период \n Попробуйте изменить даты и повторить попытку',
      UNKNOWN: 'Ошибка. Пожалуйста, попробуйте позже',
    },
    PAY_LOGIC: {
      ACTION_ERROR: 'Произошла ошибка при выполнении действия. Пожалуйста, попробуйте снова.',
      NOT_FOUND: 'Запрашиваемые данные не найдены. Пожалуйста, проверьте введенные данные и попробуйте снова.',
      NO_DEBTS: 'Нет задолженностей. Все счета оплачены.',
      PROVIDER_ANSWER_ERROR: 'Ошибка в ответе поставщика услуги. Пожалуйста, попробуйте позже.',
      SERVICE_BLOCKED_ERROR:
        'Услуга заблокирована. Пожалуйста, свяжитесь с поддержкой для получения дополнительной информации.',
      SERVICE_ERROR: 'Произошла ошибка в работе сервиса. Пожалуйста, попробуйте снова позже.',
      SYSTEM_ERROR: 'Произошла системная ошибка. Пожалуйста, попробуйте позже.',
      VALIDATION_ERROR: 'Ошибка валидации данных. Пожалуйста, проверьте введенные данные и попробуйте снова.',
      UNKNOWN: 'Ошибка. Пожалуйста, попробуйте позже',
    },
    OUTLET: {
      UNKNOWN: 'Ошибка! Пожалуйста, попробуйте позже!',
      KNOWN: 'Ошибка. Пожалуйста, попробуйте позже.',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION: 'У кассира открыта смена в точке {salePointName} в кассе {cashCode}',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION_HINT: 'Попросите кассира закрыть смену, чтобы удалить его',
      DUPLICATE_SALE_POINT_NAME_EXCEPTION: 'Точка продаж с таким названием уже есть',
      ACCOUNT_SAVING_EXCEPTION: 'Не получилось сохранить счёт. Попробуйте ещё раз',
      ACCOUNT_SAVING_IN_ACQUIRING_EXCEPTION: 'Не получилось сохранить счёт. Попробуйте ещё раз',
      CASHIER_HAS_OPEN_SHIFT_EXCEPTION: 'У кассира открыта смена. Закройте её, чтобы продолжить',
      ENTITY_NOT_FOUND_EXCEPTION: 'Не удалось найти данные, попробуйте ещё раз',
      FILE_NOT_FOUND_EXCEPTION: 'Не удалось найти данные, попробуйте ещё раз',
      SALE_POINT_EDIT_FORBIDDEN_EXCEPTION: 'У точки есть ККМ-касса. Чтобы изменять данные, нужно удалить ККМ-кассу',
      TAX_ATTRIBUTE_SAVING_EXCEPTION: 'Укажите налоговый отдел и координаты точки, чтобы продолжить',
    },
    STATEMENT: {
      PERIOD_IS_LIMITED_BY_1_YEAR: 'Максимальный период скачивания выписки — 1 год',
      UNKNOWN: 'Не удалось сформировать выписку',
    },
  },
  LOAN_CLAIMS: {
    TITLE: 'Кредиты',
    SOON: 'Кредиты скоро появятся',
  },
  QR_CODE: {
    CREATE_QR: 'Создать QR-код',
    MY_QR_CODE: 'Мой QR-код',
    RECEIVING_FUNDS: 'Прием платежей с любого банка',
    TITLE: 'QR-код',
    SELECT_ACCOUNT: 'Счет зачисления',
    COMMISSION: 'Комиссия за прием платежа 0,2%',
    DOWNLOAD: 'Скачать QR',
    PRINT: 'Распечатать QR',
    BLACK_AND_WHITE_A4: 'чёрно-белый А4',
    BLACK_AND_WHITE_A5_A6: 'чёрно-белый А5, А6',
    COLOR_A4: 'цветной А4',
    COLOR_A5_A6: 'цветной А5, А6',
    SAVE_CHANCE: 'сохранить изменения',
    CANCEL_CHANCE: 'отменить изменения',
    EMPTY_CARD: 'Нет счетов и карт',
    OPEN_ACCOUNT_CARD: 'Откройте расчетный счет или Visa Business в отделении Optima Bank',
    SHARE: 'Поделиться',
    CARD_ACCOUNTS: 'Карточные счета',
    SETTLEMENT_ACCOUNTS: 'Расчётные счёта',
    NO_ACCESS_ACCOUNT: 'Нет доступа к счету',
    GET_ACCESS: 'Обратитесь к руководству, чтобы получить доступ',
    NO_CARD: 'Нет карт',
    OPEN_CARD: 'Обратитесь к руководству, чтобы получить доступ',
    FORBIDDEN: 'Нет доступа к счёту зачисления точки',
    GET_ACCESS_SALE: 'Обратитесь к владельцу компании, чтобы получить доступ',
    OPEN_ACCESS:
      'Откройте доступ к счёту: «Настройки» → «Пользователи» → Выберите сотрудника → Выберите расчётный счёт → Включите «Создание QR»',
    ON_ACCOUNT: 'На счёт',
    ON_SALE_POINT: 'На точку',
    EMPTY_SALE_POINT: 'Чтобы создать QR-код, добавьте точку продаж',
    ASK_SALE_POINT: 'Чтобы создать QR-код, попросите руководителя добавить точку продаж',
    TAB_SALE_POINT: 'QR на точку',
    TAB_PERSONAL: 'Персональный QR',
    PURPOSE: 'Назначение',
    PURPOSE_HINT: 'В назначении можно указать за что или для кого платеж',
    ALLOW_EDIT_AMOUNT: 'Разрешить редактирование суммы',
    ALLOW_EDIT_AMOUNT_HINT: 'После включения плательщик сможет изменить указанную вами сумму',
    WITH_PURPOSE_TITLE: 'QR с назначением и\n указанной суммой',
    WITH_PURPOSE_SUBTITLE: 'Создавайте индивидуальные QR-код\n для каждого клиента или услуги',
    WITH_PURPOSE_ITEM_TITLE: 'Назначение платежа',
    WITH_PURPOSE_ITEM_TEXT:
      'Вы создаёте QR-код для клиента с указанием назначения платежа — за что, для кого и на какую сумму',
    NO_MANUAL_INPUT_TITLE: 'Оплата без ручного ввода',
    NO_MANUAL_INPUT_TEXT: 'Клиент сканирует QR и оплата формируется автоматически',
    HISTORY_TITLE: 'История платежей',
    HISTORY_TEXT:
      'В истории платежей увидите назначение, которое вы указывали и будет понятно за что перечислены средства',
    WHAT_IS_PERSONAL_QR: 'Что такое персональный QR?',
  },
  CARD: {
    TITLE: 'Карты',
    BLOCK: 'Блокировка карты',
    SETTINGS: 'Настройки',
    HISTORY: 'История',
    LIMIT: 'Лимиты',
    LIMIT_TITLE: 'Выберите тип лимита',
    BLOCK_PAYMENT_CARD: 'Вы собираетесь заблокировать платежную карту',
    ARRESTED: 'Разблокировать',
    FINAL_ARRESTED: 'Заблокирована',
    AVAILABLE_BALANCE: 'Доступный баланс',
    RULE: 'Максимальная сумма всех лимитов по всем картам не может превышать 5 000 000,00 сом. \nПересмотрите другие лимиты.',
    EMPTY_CARD: 'Нет доступных карт',
    EMPTY: 'Нет данных за период',
    YOUR_CARD_IS_BLOCKED: 'Ваша карта заблокирована.',
    YOUR_CARD_IS_BLOCKED_DESCRIPTION: 'Для того, чтобы разблокировать, обратитесь в отделение Optima Bank.',
    COMMISSION: 'Комиссия',
    FILTER_HINT: 'Для формирования выписки за дату ранее 13.02.2025 обратитесь в филиал.',
    INFORMATION: {
      CARD_ACCOUNT: 'Карточный счет',
      ALL: 'Все',
      REPLENISHMENT: 'Пополнение',
      FILTER: 'Фильтр',
      WRITE_OFF: 'Списания',
      SET: 'Применить',
      THREE: 'За 3 дня',
      WEEK: 'За неделю',
      MONTH: 'За 30 дней',
      TOTAL_RECEIPTS: 'Итоги поступления',
      TOTAL_WRITE_OFF: 'Итоги списания',
      PERIOD_START_BALANCE: 'Остаток на начало периода',
      PERIOD_END_BALANCE: 'Остаток на конец периода',
    },
    BLOCK_CARD: {
      LOSS: 'Утеря карты',
      THEFT: 'Кража карты',
      COMPROMISING: 'Компрометация карты',
      TEMPORARY: 'Временная блокировка',
      TEXT: 'После блокировки карта станет недоступна для операций. Разблокировать карту можно в отделениях Банка. При утере карты или подозрении на утечку данных рекомендуем перевыпустить карту.',
      BLOCK: 'Блокировка карты',
    },
    RENAME: {
      RENAME_CARD: 'Переименовать карту',
      NAME_CARD: 'Наименование карты',
      SET_NAME: 'Переименовать',
      DESIRED_NAME: 'Введите желаемое наименование карты',
      SUCCESS: 'Наименование карты успешно изменено',
    },

    SHARED: {
      SET: 'Установить',
      RESET: 'Сбросить',
      LIMIT_IN_DAY: 'Лимит в сутки в (сомах)',
      DATE_TO: 'Дата окончания',
      DATE_FROM: 'Дата начала',
      AVAILABLE_AMOUNT: 'Доступная сумма',
      AVAILABLE_AMOUNT_TRANSACTION: 'Доступное количество транзакций',
      AVAILABLE_AMOUNT_TRANSACTION_IN_DAY: 'Количество транзакции (в сутки)',
      AVAILABLE_OUT_OF: 'Доступно {available} из {outOf}',
      MAIN_BALANCE: 'Основной остаток',
      CARD_ACCOUNT: 'Карточный счет',
      CARD: 'Карта',
      NOT_HAVE_CARD_ACCOUNT: 'У вас нет карточного счета',
    },

    CASH_LIMIT: 'Обналичивание в ATM и POS-терминалах',
    RETAIL_CARD_PRESENT: 'Безналичные покупки через POS-терминалы',
    CARD_NOT_PRESENT: 'Интернет-покупки/платежи',
    ONLINE_PAYMENTS: 'Интернет платежи',
    FUNCTIONALITY_NOT_APPLY_RECURRING_PAYMENT: 'Данный функционал не действует на рекуррентные платежи',
    OPERATION_ALLOWED: 'Операции разрешены',

    DIALOG: {
      LIMIT: {
        SETTING: 'Установка лимита...',
        SUCCESS: 'Лимит успешно установлен',
        ERROR: 'Ошибка, попробуйте позже',
      },
      BLOCK: {
        SETTING: 'Установка блокировки...',
        SUCCESS: 'Блокировка успешно установлена',
        ERROR: 'Ошибка, попробуйте позже',
      },
      UNLOCK: {
        SETTING: 'Разблокировка карты...',
        SUCCESS: 'Карта успешно разблокирована',
        ERROR: 'Ошибка, попробуйте позже',
      },
    },

    SETTINGS_USER: {
      VIEW_CARD: 'Просмотр карты',
      BLOCK: 'Блокировка/разблокировка',
      LIMITS: 'Установка лимитов',
      DETAILS: 'Просмотр лимитов',
      SUCCESS: 'Настройки карты изменены',
      VIEW_ACCOUNT: 'Просмотр карточного счета',
      CARD_ACCOUNTS: 'Карточные счета',
      NOTIFICATION_QR: 'Пуш-уведомления по переводам QR',
      GENERATE_QR: 'Создать QR',
    },
  },
  POS: {
    STATEMENT: 'Выписки по POS',
    TITLE: 'POS-терминалы',
    BANNER: {
      TITLE: 'Закажите терминал',
      LABEL: '{value}% комиссии по картам Optima и Элкарт',
    },
    DIALOG: {
      CONFIRM_CLOSE: {
        TITLE: 'Хотите выйти?',
        LABEL: 'Черновик заявки не сохранится',
      },
    },
    QUESTIONS: {
      TERMINALS_COUNTS: 'Сколько терминалов  хотите заказать?',
      ACCOUNT: 'Куда зачислять деньги с продаж?',
      ADDRESS: 'Где поставите терминал?',
      USER: 'Кто несёт ответственность за точку?',
      WORKING_DAYS: 'Когда работаете?',
    },
    ONBOARDING: {
      TERMINAL: {
        HEADER: 'Принимайте оплату по карте и QR-коду',
        SUB_HEADER: 'Терминал работает с Visa, Mastercard, UnionPay и Элкарт',
        COMMISSION: '{value}% комиссии',
        COMMISSION_HINT: 'По картам Optima и системы Элкарт',
        CARD_HINT: 'По картам других банков и систем',
        DELIVERY: 'Быстрая доставка',
        DELIVERY_HINT: 'В течение трёх дней',
        FLEX_COMMISSION: 'Гибкие комиссии по приёму платежей',
        ABOUT_TARIFF: 'Подробнее о тарифах',
      },
      PHOTO: {
        HEADER: 'Подготовьте два фото точки для заявки',
        SUB_HEADER: 'Можно сделать фото при оформлении или заранее — как вам удобнее',
        EXPECTATION: 'Что ждём от фото',
        OUTSIDE: 'Снаружи',
        OUTSIDE_HINT: 'Видно вывеску и вход',
        INSIDE: 'Внутри',
        INSIDE_HINT: 'Видно прилавок и помещение',
      },
      AGREEMENT: {
        LABEL: 'Нажимая «Оформить заявку», вы соглашаетесь с',
        LINK: 'условиями договора',
      },
    },
    ORDER: {
      TITLE: 'Заявка на терминал | Заявки на терминал',
      SUB_TITLE: 'Заказать терминал',
      APPLICATION: 'Заявка | Заявки',
      SUBMIT_APPLICATION: 'Оформить заявку',
      ADD_KKM: 'Добавить кассовый аппарат (ККМ) к заказу',
      ENROLLMENT_ACCOUNT: 'Счет зачисления',
      STORE_NAME: 'Название точки',
      OFFER_TYPES: 'Ваши товары или услуги',
      HAS_SECURITY: 'В точке есть камеры или охрана',
      FRONT_PHOTO: 'Загрузить фото точки снаружи',
      FRONT_PHOTO_DOWNLOADED: 'Точка снаружи загружена',
      BACK_PHOTO: 'Загрузить фото точки внутри',
      BACK_PHOTO_DOWNLOADED: 'Точка внутри загружена',
      WORKING_DAYS_HINT: 'Выделите один день недели или несколько, чтобы указать график',
      OPENING: 'Открытие',
      CLOSING: 'Закрытие',
      ADD_SCHEDULE: 'Добавить расписание',
      DELETE_SCHEDULE: 'Удалить расписание',
      SUBMIT: 'Отправить заявку',
      SENT_TO_REVIEW: 'Отправили на рассмотрение',
      SENT_HINT: 'За статусом можно следить в разделе «Заявки»',
      TO_APPLICATIONS: 'К заявкам',
    },
    ABOUT_KKM: {
      TITLE: 'Что такое кассовый аппарат?',
      SUB_TITLE: 'Кассовый аппарат или ККМ',
      LI_1: 'помогает вести учёт продаж',
      LI_2: 'выдаёт фискальные чеки',
      LI_3: 'сам передаёт данные в налоговую',
      FOOTER: 'Добавьте ККМ к заказу, чтобы снять с себя лишнюю бюрократию',
    },
    RULE: {
      INVALID_PHOTO_EXTENSION:
        'Загружен файл запрещенного типа. Разрешенные типы файлов: .heic .png .jpeg\nПожалуйста, удалите файл и загрузите файл разрешенного типа',
      FILE_LARGE_ERROR:
        'Размер загруженного вами файла превышает максимально допустимый размер в 5 мегабайт.\nПожалуйста, удалите файл и загружите файл меньшего размера',
    },
    STATUS: {
      COMPLETED: 'Одобрена',
      IN_PROCESS: 'Рассматриваем',
      REJECTED: 'Отклонена',
      REJECT_REASON: 'Причина отклонения',
    },
    TASKS: {
      TITLE: 'Заявки',
      STORE_NAME: 'Торговая точка',
      TERMINALS_COUNT: 'Количество терминалов',
      CREATE_DATE: 'Дата заявки',
      ERROR: 'Не удалось получить заявки',
    },
    DETAILS: {
      TERMINALS: 'Терминалы',
      TO_ORDER: 'К заказу',
      KKM: 'Кассовый аппарат (ККМ)',
      PLACE: 'Точка',
      NAME: 'Название',
      OFFER_TYPES: 'Товары или услуги',
      RESPONSIBLE_PERSON: 'Ответственное лицо',
      WORK_SCHEDULE: 'График работы',
      ERROR: 'Не удалось получить детали заявки',
    },
  },
  SALARY: {
    ONBOARDING: {
      TITLE: 'Доверьте выплаты банку: экономьте на комиссиях и забудьте о рутине.',
      CONNECT: 'Подключиться',
      FEE_FREE: { TITLE: '0% Комиссии', DESCRIPTION: 'Перечисления сотрудникам - абсолютно бесплатно.' },
      INSTANT_CREDIT: {
        TITLE: 'Моментальное зачисление',
        DESCRIPTION: 'Деньги на картах сразу после подписания реестра.',
      },
      SUPPORT: { TITLE: 'Надежная поддержка', DESCRIPTION: 'Обеспечим полное сопровождение.' },
      ANYTIME: { TITLE: 'Начисляйте 24/7', DESCRIPTION: 'Отправляйте реестр круглосуточно - в любое время.' },
      STEP_TWO: {
        TITLE: 'Обратитесь в офис банка, где открывали расчётный счёт',
        SUBTITLE:
          'Подключение к зарплатному проекту занимает немного времени. После подключения вы сможете удобно начислять зарплату сотрудникам через Optima Business.',
        ADDRESS_LABEL: 'Адрес офиса банка',
        IMPORTANT: 'Важно! Возьмите с собой паспорт и необходимые документы компании.',
      },
    },
    BANNER: {
      TITLE: 'Зачисляйте зарплату с расчётного счёта',
      INFO: 'Создавайте ведомости на сайте без предварительных переводов на транзитный счёт и Excel-таблиц',
    },
    DELETE_ALL: 'Удалить всех',
    LOADING_CHANGE_SETTINGS: 'Загружаем...',
    SUM: 'Сумма',
    TOTAL: 'Итого',
    WITHDRAWAL_ACCOUNT: 'Счет списания',
    CODE_COMPANY: 'Код компании',
    NAME_COMPANY: 'Наименование компании',
    ACCOUNT_NUMBER: 'Номер расчетного счета',
    AMOUNT_CREDIT: 'Сумма зачисления на карт-счета',
    SELECT_TEMPLATE: 'Выбрать из шаблонов',
    CREATE_SALARY: 'Создать ведомость',
    UPLOAD_TEMPLATE: 'Загрузить Excel ведомость',
    EMPLOYEES: 'Сотрудники',
    IN_REVIEW: 'На проверке',
    TO_STATEMENTS: 'К списку ведомостей',
    CREDITED_AMOUNT: 'Сумма зачислений',
    SEND_STATEMENT: 'Отправить на проверку',
    ADD_STATEMENT: 'Добавить ведомость',
    DOWNLOAD_TEMPLATE: 'Скачать Excel-шаблон',
    SELECTED_EMPLOYEE: 'Выбрано сотрудников',
    ID_COMPANY: 'ID Компании',
    TRANSFER_ACCOUNT: 'Счет зачисления',
    SELECT_ALL: 'Выбрать всех',
    ADD_EMPLOYEE: 'Добавить сотрудника',
    ADD_TEMPLATE: 'Добавить в шаблон',
    AMOUNT_COMMISSION: 'Сумма комиссии',
    TOTAL_SUM: 'Сумма итого',
    COMPANY_NAME: 'Название компании',
    TRANSIT: 'Транзитный счет',
    RKO: 'Расчетный счет',
    STATEMENT_NAME: 'Название ведомости',
    NOT_CONNECTED_SALARY: 'Зарплатный проект не подключен',
    IMPORT: 'Загрузить ведомость',
    CAUSE: 'Причина',
    TOTAL_AMOUNT: 'Общая сумма',
    BACK_TO_SALARY: 'Вернуться в Зарплатный проект',
    DELETE_STATEMENT: 'Ведомость удалена',
    DELETING_STATEMENT: 'Ведомость удаляется...',
    INFO: {
      TITTLE: 'Весь путь от загрузки ведомости до зачисления средств сотрудникам состоит из следующих шагов:',
      SUB_TITTLE:
        '1) Загрузить корректно заполненную ведомость. Важно использовать утвержденный шаблон!\n2) Далее ведомость попадает на 1ый этап, где система автоматически проверяет ведомость на корректность заполнения, активность карт сотрудников и остаток на счете списания.\n3) При получении статуса «Обработано» на 1ом этапе, ведомость попадает на 2ой этап в статусе «Готов к подписанию», после чего требуется отправить его на подпись до 17:00 и подписать до 17:25. Статус «Завершен» означает, что денежные средства зачислены сотрудникам.',
    },
    MORE_DETAILS: 'Подробнее',
    TITLE: 'Зарплатный проект',
    ATTACHED_FILE: 'Прикрепленный файл',
    PAY_CONTROL_NOT_AVAILABLE:
      'Невозможно отправить ведомость на подпись. У одного из подписантов отсутствует PayControl.',
    TABS: {
      EMPLOYEE: 'Сотрудники',
      STATEMENT: 'Ведомость',
    },
    FAQ: {
      TITLE: 'FAQ — Зарплатный проект',
      VIDEO: 'Смотреть видеоинструкцию',
      TOPICS: {
        CREATE: {
          TITLE: 'Создание зарплатной ведомости',
          WHEN: {
            TITLE: 'Когда использовать',
            TEXT: 'Если необходимо вручную сформировать и отправить зарплатную ведомость сотрудникам.',
          },
          STEPS: {
            TITLE: 'Порядок действий',
            ITEM: {
              1: 'Перейдите в раздел «Зарплатный проект» → «Ведомости».',
              2: 'Нажмите «Добавить ведомость» → «Создать ведомость».',
              3: 'Выберите счет списания.',
              4: 'Добавьте сотрудников и укажите суммы выплат.',
              5: 'После заполнения ведомость получит статус «Готов к подписанию».',
              6: 'Откройте ведомость и нажмите «На подпись».',
              7: 'Перейдите в раздел «Платежи на подпись».',
              8: 'Выберите ведомость и нажмите «Подписать».',
            },
          },
          EXTRA: {
            TITLE: 'Дополнительные возможности',
            ITEM: {
              1: 'После завершения ведомости можно скачать PDF-документ с печатью банка.',
              2: 'Для регулярных выплат используйте кнопку «Повторить» — система автоматически подставит сотрудников и суммы из предыдущей ведомости.',
            },
          },
        },
        EXCEL: {
          TITLE: 'Загрузка зарплатной ведомости через Excel',
          NOTICE:
            'Важно! Если ведомость получила статус «Отказ», проверьте корректность заполнения Excel-шаблона и повторите загрузку.',
          WHEN: {
            TITLE: 'Когда использовать',
            TEXT: 'Если необходимо массово загрузить данные сотрудников из Excel-файла.',
          },
          STEPS: {
            TITLE: 'Порядок действий',
            ITEM: {
              1: 'Перейдите в раздел «Зарплатный проект» → «Ведомости».',
              2: 'Нажмите «Скачать Excel-шаблон».',
              3: 'Заполните данные сотрудников в шаблоне.',
              4: 'Сохраните файл на устройстве.',
              5: 'Нажмите «Загрузить ведомость».',
              6: 'Выберите заполненный Excel-файл.',
              7: 'После успешной загрузки ведомость получит статус «Готов к подписанию».',
              8: 'Откройте ведомость и нажмите «На подпись».',
              9: 'Перейдите в раздел «Платежи на подпись».',
              10: 'Выберите ведомость и нажмите «Подписать».',
            },
          },
          REQUIREMENTS: {
            TITLE: 'Требования к Excel-шаблону',
            ITEM: {
              1: 'Не изменяйте форматирование файла.',
              2: 'Не удаляйте формулы.',
              3: 'Не оставляйте пустые строки.',
              4: 'Соблюдайте структуру шаблона.',
            },
          },
          EXTRA: {
            TITLE: 'Дополнительные возможности',
            ITEM: {
              1: 'После завершения ведомости можно скачать PDF-документ с печатью банка.',
              2: 'Для регулярных выплат используйте кнопку «Повторить».',
            },
          },
        },
        CONNECT_EMPLOYEE: {
          TITLE: 'Подключение сотрудника к зарплатному проекту',
          NOTICE:
            'Важно! Перед подключением убедитесь, что сотрудник добавлен в систему и имеет необходимые права доступа.',
          WHEN: {
            TITLE: 'Когда использовать',
            TEXT: 'Когда сотруднику необходимо предоставить доступ к разделу «Зарплатный проект» для создания и просмотра зарплатных ведомостей, просмотра сумм к начислению и управления сотрудниками.',
          },
          STEPS: {
            TITLE: 'Порядок действий',
            ITEM: {
              1: 'Перейдите в раздел «Настройки» → «Пользователи».',
              2: 'Выберите сотрудника.',
              3: 'Активируйте переключатель «Зарплатный проект».',
            },
          },
          RESULT: {
            TITLE: 'Результат',
            ITEM: {
              1: 'После подключения сотруднику будет доступен расчетный счет в рамках зарплатного проекта.',
              2: 'При отключении переключателя доступ к зарплатному проекту будет закрыт.',
            },
          },
        },
        ERRORS: {
          TITLE: 'Ошибки зарплатной ведомости',
          NOTICE:
            'Рекомендация. Перед повторной отправкой проверьте корректность данных сотрудников, суммы выплат и выбранный счет списания.',
          WHEN: {
            TITLE: 'Когда использовать',
            TEXT: 'Если ведомость была отклонена или не прошла обработку.',
          },
          REASONS: {
            TITLE: 'Возможные ошибки',
            ITEM: {
              1: {
                TERM: 'Отклонена подписантом',
                TEXT: 'Документ был отклонен на этапе подписания.',
              },
              2: {
                TERM: 'Истек срок подписи',
                TEXT: 'Документ слишком долго находился в ожидании подписи.',
              },
              3: {
                TERM: 'Не прошла проверку',
                TEXT: 'В ведомости обнаружены ошибки или некорректные данные.',
              },
              4: {
                TERM: 'Отклонена банком',
                TEXT: 'Документ не прошел обработку на стороне банка.',
              },
            },
          },
          RETRY: {
            TITLE: 'Повторная отправка ведомости',
            ITEM: {
              1: 'Откройте ведомость с ошибкой.',
              2: 'Нажмите «Повторить».',
              3: 'Система автоматически восстановит: счет списания; список сотрудников; суммы выплат.',
              4: 'При необходимости внесите изменения.',
              5: 'Нажмите «Отправить на проверку».',
            },
          },
        },
      },
    },
    EMPLOYEE: {
      EMPTY: 'Список пуст',
      FILTER_EMPTY: 'Сотрудник с указанными параметрами не найден',
      SEARCH_PLACEHOLDER: 'Поиск сотрудника',
      PAY_CONTROL_NOT_AVAILABLE: 'Действия с сотрудниками недоступны. У одного из подписантов отсутствует PayControl.',
      ADD: {
        INN: 'Поиск по ИНН',
        INN_ERROR: 'Введите 14-значный ИНН',
        LIMIT: 'В одном документе можно добавить не более {count} сотрудников',
        TO_ADD: 'Сотрудники к добавлению:',
        ACCOUNT_REQUIRED: 'Выберите карту',
        SEARCH_RESULTS: 'Результаты поиска',
        ALREADY_ADDED: 'Этот сотрудник уже добавлен',
        ALREADY_IN_PROJECT: 'Сотрудник уже является участником этого зарплатного проекта.',
        CARD_NUMBER: 'Номер карты',
        ACCOUNT: 'Счёт',
        NO_CARDS: 'У сотрудника нет доступных карт для зачисления заработной платы',
        LOADING_CARDS: 'Загрузка карт...',
        NOT_FOUND: 'По данному ИНН ничего не найдено',
        SAVE_CHANGES: 'Сохранить изменения',
        SEND_FOR_SIGNING: 'Отправить на подпись',
        SUCCESS: 'Сотрудник будет добавлен в зарплатный проект после подтверждения первым подписантом.',
        SUCCESS_BULK: 'Сотрудники будут добавлены в зарплатный проект после подтверждения первым подписантом.',
        GOT_IT: 'Понятно',
        SELECT_ACCOUNTS: 'Выберите карту для всех сотрудников',
        EMPTY_LIST: 'Добавьте хотя бы одного сотрудника',
      },
      EDIT: {
        SENT_BUTTON: 'Понятно',
        TITLE: 'Редактирование сотрудника',
        NO_CARDS: 'У сотрудника отсутствуют доступные карты',
        SAME_ACCOUNT: 'Новый счёт совпадает с текущим',
        SENT_MESSAGE: 'Счёт зачисления будет изменен после подтверждения изменений первым подписантом.',
      },
      RESTORE: {
        ACTION: 'Восстановить',
        CONFIRM_TITLE: 'Восстановить сотрудника в зарплатный проект?',
        CONFIRM_TITLE_BULK: 'Восстановить сотрудников в зарплатный проект?',
        SENT_MESSAGE: 'Сотрудник будет повторно добавлен в зарплатный проект после подтверждения первым подписантом.',
        SENT_MESSAGE_BULK:
          'Сотрудники ({count}) будут повторно добавлены в зарплатный проект после подтверждения первым подписантом.',
        RESET_SELECTION: 'Сбросить выделение',
      },
      DELETE: {
        CONFIRM_TITLE: 'Удалить сотрудника с зарплатного проекта?',
        CONFIRM_TITLE_BULK: 'Удалить сотрудников из зарплатного проекта?',
        SENT_MESSAGE: 'После подтверждения Первым подписантом сотрудник будет удалён из зарплатного проекта.',
        SENT_MESSAGE_BULK:
          'После подтверждения Первым подписантом сотрудники ({count}) будут удалены из зарплатного проекта.',
      },
      FILTER: {
        TITLE: 'Фильтр и сортировка',
        BY_CREATED_DATE: 'По дате добавления',
        NEWEST_FIRST: 'Сначала новые',
        OLDEST_FIRST: 'Сначала старые',
        APPLY: 'Применить',
        RESET: 'Сбросить всё',
      },
      CHIPS: {
        ADDED: 'Добавленные',
        FOR_SIGNING: 'На подпись',
        DELETED: 'Удаленные',
        REJECTED: 'Отклонённые',
      },
      ERROR: {
        TITLE: 'Произошла ошибка при загрузке сотрудников',
      },
      STATUS_LABEL: {
        EMPLOYEE_IN_PROCESSING_BANK: 'В обработке банком',
        EMPLOYEE_ERROR_CREATED: 'Не удалось добавить сотрудника',
        EMPLOYEE_REJECTED: 'Отклонено первым подписантом',
        EMPLOYEE_CLOSED: 'Удалён',
        EMPLOYEE_CARD_NOT_LINKED_YET: 'Карта ещё не привязана',
        EMPLOYEE_CARD_FAILED_ADD: 'Не удалось добавить карту',
        EMPLOYEE_CARD_BLOCKED: 'Карта заблокирована',
        EMPLOYEE_CARD_SUCCESS: 'Сотрудник добавлен',
        EMPLOYEE_AWAITING_CREATION: 'Ожидает добавления',
        EMPLOYEE_AWAITING_EDIT: 'Ожидает редактирования',
        EMPLOYEE_AWAITING_CLOSING: 'Ожидает удаления',
        UNKNOWN: 'Неизвестный статус',
      },
    },
    STATEMENT: {
      DIALOG: {
        RETURN: 'Назад',
        SALARY_RELOADING: 'Идет процесс перезапуска ведомости...',
        STATEMENT_IS_REJECTED: 'Идет процесс отклонения ведомости...',
        STATEMENT_REJECTED: 'Ведомость отклонена',
        SENDING_STATEMENT: 'Идет процесс отправки ведомости на подписание...',
        STATEMENT_SENT: 'Ведомость отправлена',
        STATEMENT_SIGNED: 'Ведомость успешно подписана',
        STATEMENT_IS_SIGNED: 'Ведомость на сумму {sum} {currency} находится в процессе подписания...',
      },
      COLUMN_TABLE: {
        NUMBER: '№',
        FILE_NAME: 'Название',
        TOTAL_AMOUNT: 'Итоговая сумма',
        NUMBER_CARD: 'Номер карт-счета',
        DOWNLOAD_DATE: 'Дата создания',
      },
      EMPTY: 'Нет загруженных ведомостей',
      ERROR: {
        TITLE: 'Произошла ошибка при загрузке ведомости',
      },
    },
    CONTRACT: {
      TITLE: 'Информация по зарплатному договору',
      ID: 'ID зарплатного проекта:',
      ACCOUNT: 'Транзитный счет:',
      STATUS_LABEL: {
        CONTRACT_ON_VERIFICATION: 'Контракт на верификации',
        CONTRACT_VERIFICATED: 'Контракт одобрен верификатором',
        CONTRACT_REJECTED: 'Контракт отклонён верификатором',
        CONTRACT_PENDING_CLOSURE: 'Контракт ожидает закрытия',
        CONTRACT_CLOSED: 'Контракт закрыт',
        CONTRACT_PENDING_UNCLOSE: 'Контракт ожидает открытия',
      },
    },
    DOWNLOAD: {
      TEXT: 'Скачать шаблон',
      ERROR: 'Произошла ошибка при загрузке файла.',
      ERROR_HELP: 'Пожалуйста, нажмите кнопку Скачать еще раз.',
      DOWNLOADING_STATEMENT: 'Ведомость скачивается',
    },
    ERROR: {
      TITLE: 'Произошла ошибка при загрузке ведомости',
      MIN_AMOUNT: 'Введите сумму от 1 {currency}',
      MAX_AMOUNT: 'Введите сумму до 1 000 000 000 {currency}',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'На счету недостаточно средств',
    },
    NOTIFICATION: {
      STATUS: {
        ERROR: {
          TEXT: 'Банк отклонил зарплатную ведомость. Сумма {amount} {currency}.',
        },
        SUCCESS: {
          TEXT: 'Банк одобрил зарплатную ведомость. Сумма {amount} {currency}.',
        },
      },
    },
  },
  LETTER: {
    DOWNLOAD: {
      ERROR: 'Произошла ошибка при загрузке файла.',
      ERROR_HELP: 'Пожалуйста, нажмите кнопку Скачать еще раз.',
    },
    TITLE: 'Письма',
    ATTACHED_FILE: 'Прикрепленный файл',
    CREATED: 'Создано: ',

    REVOKE: 'Отклонить',
    SIGN: 'Подписать',
    FOR_SIGN: 'На подпись',
    DELETE: 'Удалить',

    NOTIFICATION: {
      TITLE: 'Новое письмо из банка',
      TEXT: 'Пришел ответ из банка на ваше письмо №{number}',
    },
    EMPTY: {
      OUTGOING: 'У вас нет исходящих писем',
      INCOMING: 'У вас нет входящих писем',
    },
    ERROR: {
      TITLE: 'Произошла ошибка при загрузке писем',
    },
    NAV: {
      OUTGOING: 'Исходящие',
      INCOMING: 'Входящие',
    },
    CREATE: {
      CREATE_LETTER: 'Создать письмо',
      DATE: 'Дата создания',
      NAME_COMPANY: 'Наименование компании',
      TOTP: 'Для подтверждения отправки письма в банк, пожалуйста, введите TOTP-код',
      ENTER_TOTP: 'Введите TOTP-код',
      SELECT: {
        SUBJECT: 'Тема письма',
        SUBJECT_EMPTY: 'Нажмите для выбора темы письма',
        MONEY_TRANSFER: 'Документы по денежным переводам',
        PAYMENT_CANCELLATION: 'Отмена платежа',
        PERSONAL_DOCUMENT: 'Персональные документы',
        OTHER: 'Другое',
      },
      ENTER_SUBJECT: 'Введите вашу тему письма',
      ENTER_TEXT: 'Введите текст письма',
      ATTACH_FILE: 'Прикрепить файл',
      ALLOWED_TYPES: '(10 МБ, разрешенные типы файлов: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt)',
      FOR_SIGN: 'На подпись',
      RULES: {
        ENTER_SELECT: 'Выберите тему создаваемого письма из этого выпадающего списка',
        ENTER_TEXT: 'Напишите текст создаваемого письма в этом поле',
        ENTER_OTHER_TEXT: 'Напишите тему создаваемого письма в этом поле',
        INVALID_EXTENSION:
          'Прикреплен файл запрещенного типа. Разрешенные типы файлов: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt\nПожалуйста, удалите прикрепленный файл и прикрепите файл разрешенного типа',
        FILE_LARGE:
          'Размер прикрепленного вами файла превышает максимально допустимый размер в 10 мегабайт.\nПожалуйста, удалите прикрепленный файл и прикрепите файл меньшего размера',

        INVALID_TOTP: 'Вы ввели неверный TOTP-код. Пожалуйста, введите верный TOTP-код заново',
        INVALID_CHARACTER_TITLE: 'Вы использовали недопустимые символы в теме письма: ',
        INVALID_CHARACTER_MESSAGE: 'Вы использовали недопустимые символы в тексте  письма: ',
      },
      DIALOG: {
        SENDING: 'Отправка письма',
        REPEAT: 'Повторить',
        NOT_SEND: 'Письмо не было отправлено',
        COME_BACK: 'Вернуться назад',
        SENT_FOR_SIGN: 'Письмо отправлено на подпись',
        COME_BACK_LETTER: 'Перейти в письма',
        SAVED_TO_DRAFT: 'Письмо сохранено как черновик',
        ERROR_AFTER_DRAFT: 'Не удалось отправить письмо на подпись. Письмо сохранено как черновик',
        SUCCESS_DELETE: 'Письмо было удалено',
        FAILED_DELETE: 'Не удалось удалить письмо',
        FAILED_SAVED_TO_DRAFT: 'Не удалось сохранить письмо в черновике',
        FAILED_SEND_FOR_SIGN: 'Не удалось отправить письмо на подпись',
        SIGN_LETTER: 'Письмо подписано',
        FAILED_SIGN_LETTER: 'Не удалось подписать письмо',
        SUCCESS_REVOKE: 'Письмо отклонено',
        FAILED_REVOKE: 'Не удалось отклонить письмо',
      },
    },
    STATUS: {
      OUTGOING: {
        NOT_PROCESSED: 'Не обработано',
        IN_PROCESSING: 'В обработке',
        PROCESSED: 'Обработано',

        ON_VERIFICATION: 'На подписании',
        FIRST_SIGN_IN_PAY_CONTROL: 'На подписании',
        TIMEOUT_CANCELED_SIGN_ONE: 'Отказ по таймауту',
        CANCELED_SIGN_ONE: 'Отказан',
        DRAFT: 'Черновик',
      },
      INCOMING: {
        NOT_PROCESSED: 'Новое письмо',
        PROCESSED: 'Прочитано',
      },
    },
  },
  OUTLET: {
    LUNCH_BREAK: 'Обед',
    NEW_POINT: 'Новая точка продаж',
    CASH_ADD: 'Добавить кассу',
    POINT_ADD: 'Добавить точку',
    CASH: 'Касса',
    SALE_POINTS: 'Точки продаж',
    SALE_POINT: 'Точка продаж',
    ALL_POINTS: 'Все точки',
    EMPLOYEES: 'Кассиры',
    CREATE_QR: 'Создать QR-код',
    SHOW_ALL: 'Посмотреть всех',
    QR_CODE: 'QR-код',
    NAME: 'Название',
    DELETE_ALL: 'Удалить всех',
    SELECT_ALL: 'Выбрать всех',
    ADD_EMPLOYEE: 'Добавить кассира',
    ADD_ADDRESS: 'Добавить адрес',
    ADD_PHONE: 'Добавить номер',
    CHANGE_ACCOUNT_SETTINGS: 'Измените доступ к счёту в Настройках',
    SORT_NEWEST: 'Сначала новые',
    SORT_OLDEST: 'Сначала старые',
    SORT_ALPHABETICALLY: 'По алфавиту',
    NEW_CASH: 'Новая касса',
    GRANT_ACCESS: 'Выдать доступ',
    EMPTY_EMPLOYEES: 'Кассиров пока нет',
    EMPTY_SEARCH_EMPLOYEES: 'Нет кассиров с таким именем',
    EMPTY_SEARCH_POINT: 'Нет точек с таким названием',
    POINT_ACCESS_DENIED: 'Нет доступа к точкам продаж',
    CASH_ACCESS_DENIED: 'Нет доступа к кассам',
    EMPLOYEE_ACCESS_DENIED_CASH: 'У кассира нет доступа к кассам',
    EMPTY_CASHES: 'Нет касс с таким номером',
    ONBOARDING: {
      HEADER: 'Добавьте точку продаж',
      SUB_HEADER: 'Сможете следить за продажами и добавлять кассиров в приложении',
      QR: 'Создайте QR-код для каждой кассы',
      HISTORY: 'Смотрите историю продаж по точке и каждой кассе',
      ACCESS: 'Выдавайте доступ кассирам, чтобы они смотрели историю',
      ADD_POINT: 'Добавить точку продаж',
    },
    REVOKE_ACCESS: 'Отозвать доступ',
    EDIT_WITH_KKM: 'У точки есть ККМ-касса. Чтобы изменять данные, нужно удалить ККМ-кассу',
    FORM: {
      QUESTIONS: {
        NAME: 'Как называется точка продаж?',
        ACCOUNT: 'Куда зачислять деньги?',
        ADDRESS: 'Добавить адрес',
        PHONE: 'Как связываться с точкой?',
        SOCIAL: 'Ссылки на адрес и социальные сети точки',
      },
      POINT_NAME: 'Название точки',
      CHECK_NAME: 'Название для чеков',
      CHECK_HINT: 'Введите название для чеков латиницей — оно показывается в чеках продаж',
      ACCOUNT_HINT: 'Если поменяете счёт зачисления, создайте новый QR-код',
      REGION: 'Область',
      CITY: 'Областной район или город',
      DISTRICT: 'Городской район или село',
      ADMINISTRATIVE_TERRITORY: 'Административная территория',
      IN_BUILDING: 'В здании',
      NEARBY: 'Рядом',
      COMPANIES_IN_BUILDING: 'Выберите организацию',
      STREET_OR_MKR: 'Улица или микрорайон',
      HOUSE: 'Дом',
      POSTAL_CODE: 'Почтовый индекс',
      TRADE_CENTER_OR_MARKET_POINT: 'Точка в торговом центре или на рынке',
      WORKING_HOURS: 'Время работы',
      WORKING_FROM: 'С',
      WORKING_TO: 'До',
      SELECTED_COMPANY: 'Выбранная компания',
      NEARBY_COMPANIES: 'Компании рядом',
      MAP_PICKER_TITLE: 'Добавить адрес',
      ADDRESS_SEARCH_PLACEHOLDER: 'Введите адрес компании',
      CURRENT_LOCATION: 'Текущее местоположение',
      GEOLOCATION_ERROR: 'Не удалось определить текущее местоположение',
      LOAD_MORE_COMPANIES: 'Показать ещё',
      COMPANY_BRANCHES_LOAD_ERROR: 'Не удалось загрузить компании. Попробуйте ещё раз',
      ORGANIZATION_BRANCHES: 'Филиалы организации',
      SELECT_BRANCH: 'Выберите филиал',
      SUGGEST_ORG_BRANCHES: '{count} филиалов, {city}',
      ADDRESS_NOT_FOUND: 'Адрес не найден',
      TWO_GIS_NOT_FOUND: 'Ничего не нашлось, попробуйте уточнить запрос',
      ADD_PHONE: 'Добавить номер',
      PHONES: 'Номера телефонов',
      TWO_GIS: 'Ссылка на адрес точки в 2ГИС',
      TWO_GIS_SHORT: '2ГИС',
      COPY_LINK: 'Ссылка скопирована',
      ENTER_TWO_GIS: 'Вставьте ссылку на 2ГИС',
      SOCIAL_NETWORK: 'Ссылка на социальную сеть точки',
      SOCIAL_NETWORK_SHORT: 'Социальные сети',
      PLACED_IN_MALL: 'Точка в торговом центре или на рынке',
      ADD_SOCIAL_NETWORK: 'Добавить',
      ENTER_SOCIAL_NETWORK: 'Вставьте ссылку на соцсеть',
      MALL: 'Торговый центр',
      MALL_NAME: 'Название торгового центра',
      FLOOR: 'Этаж',
      BOUTIQUE: 'Номер бутика',
      MARKET: 'Рынок',
      MARKET_NAME: 'Название рынка',
      MARKET_ROW: 'Ряд',
      CONTAINER: 'Контейнер',
    },
    RULE: {
      SAME_PHONE: 'Этот номер уже есть. Введите другой номер телефона',
      ACCOUNT_FORBIDDEN: 'Нет доступа к счёту',
    },
    DIALOG: {
      POINT_IS_READY: 'Точка «{name}» готова к работе',
      ADD_MORE_POINT: 'Добавить еще точку',
      TO_POINT_LIST: 'К списку точек',
      CHANGE_ACCOUNT: {
        TITLE: 'Счёт зачисления поменяется для всех торговых точек',
        DESCRIPTION:
          'Во всех точках по договору №{number} один счёт — если вы его измените, он обновится во всех этих точках:',
      },
      QT_HINT_INVITED:
        'Отправьте ссылку и QR-код. Когда кассир войдет в Optima Business, разрешите ему доступ в разделе «Кассиры»',
      QR_HINT:
        'QR-коды касс продолжат работать, но деньги будут поступать на другой расчётный счёт. Создайте QR-коды заново, чтобы деньги поступали на новый счёт зачисления',
      CASH_IS_READY: 'Касса {code} готова к работе',
      CASH_IS_READY_HINT: 'Она доступна в «{name}»',
      ADD_MORE_CASH: 'Добавить ещё кассу',
      TO_CASH_LIST: 'К списку касс',
      REVOKE_ACCESS_TITLE: 'Отозвать доступ ко всем кассам?',
      REVOKE_ACCESS_MESSAGE: '{name} не сможет следить за продажами',
      DO_YOU_WANT_REVOKE: 'Хотите отозвать доступ ко всем кассам?',
      FINISH_CHANGES_TO_REVOKE: 'Завершите изменения и нажмите «Отозвать доступ»',
      DELETE_CASHIER: 'Удалить кассира «{name}»?',
      DELETE_CASHIER_MESSAGE: 'Кассир {name} больше не сможет зайти в Оптима Бизнес',
      CASHIER_DELETED: 'Кассир удалён',
      CHANGES_WILL_NOT_BE_SAVED: 'Изменения не сохранятся, если вы их вносили',
      ACCESS_REVOKED: 'Доступ отозван',
      CASHIER_STATUS_INFO: 'Кассиру осталось ввести логин и временный пароль, чтобы войти в приложение',
      CASHIER_STATUS_SUCCESS: 'Кассир прошёл регистрацию может пользоваться приложением',
      CONFIRM_CLOSE: {
        ADD_OUTLET: 'Данные точки не сохранятся, если вы их вводили',
        ADD_CASH: 'Данные кассы не сохранятся, если вы их вводили',
        EDIT_CASH: 'Изменения в кассе не сохранятся',
        ADD_CASHIER: 'Данные кассира не сохранятся, если вы их вводили',
      },
      ACTION: {
        REVOKE: 'Отозвать',
        COPY_LINK: 'Скопировать ссылку',
      },
    },
    MORE_OUTLETS: 'еще больше точек | еще {count} точка | еще {count} точки | еще {count} точек',
    MORE_EMPLOYEES: 'больше сотрудников | {count} сотрудник | {count} сотрудника | {count} сотрудников',
    MORE_CASHES: 'больше касс | {count} касса | {count} кассы | {count} касс',
    MORE_CASHES_PREFIX: 'еще больше касс | еще {count} касса | еще {count} кассы | еще {count} касс',
    DETAILS: {
      SALES: 'Продажи',
      CASH_REGISTERS: 'Кассы',
      ABOUT_POINT: 'О точке',
      LIST_QR: 'Список QR',
    },
    EMPLOYEE: {
      TITLE: 'Новый кассир',
      ACCESS_OTHER_CASH: 'Выдать доступ к другим кассам',
      INFO_SUBTITLE: 'Укажите данные кассира',
      ACCESS_SUBTITLE: 'К каким кассам выдать доступ?',
      ACCESS_SELECTED_CASH: 'Каким кассирам выдать доступ?',
      NOT_FOUND: 'Не нашли клиента Оптимы с таким ИНН',
      ALREADY_ACTIVE: 'Уже есть кассир с таким ИНН',
      DID_NOT_SELECTED: 'Выберите минимум одну кассу',
      SELECT_ALL: 'Выбрать все кассы',
      CASH_NUMBER: 'Номер кассы',
      ADD_MORE: 'Добавить ещё кассиров',
      TO_LIST: 'К списку кассиров',
      MUST_ENTER_LOGIN_PASSWORD: '{name} должен ввести логин и временный пароль, чтобы войти в приложение',
      EMPLOYEE_WITH_ACCESS: 'Кассиры с доступом',
      FIRST_OR_SECOND_NAME: 'Имя или фамилия',
      ABOUT_EMPLOYEE: 'О кассире',
      CASHES: 'Кассы',
      QR_ADD: 'Сгенерировать QR-код',
      INN_ADD: 'Добавить по ИНН',
    },
    STATUS: {
      INIT: 'Отправили данные для входа',
      CONFIRM: 'Добавлен',
      ON_VERIFICATION: 'На рассмотрении',
      DECLINED: 'Отклонена',
      APPROVED: 'Принята',
    },
    BANNER: {
      TITLE: 'Добавили все точки продаж в одно место',
      DESCRIPTION: 'Теперь можно просматривать полную информацию о терминалах и по QR-платежам',
    },
    HISTORY_INVITED: 'История заявок',
    APPROVED_CASHIER: '"{name}" добавлен в вашу компанию',
    DECLINED_CASHIER: 'Заявка "{name}" отменена',
    CANCEL_CASHIER: 'Отменить заявку кассира "{name}"?',
    NOT_CANCEL: 'Нет, не отменять',
    YES_CANCEL: 'Да, отменить',
    ACCEPTED: 'Принят {name}',
    REJECTED: 'Отклонен {name}',
    APPLICATION_SENT_TO_MANAGER: 'Заявка отправлена\nруководителю',
    INVITED: 'Приглашенные',
    PAYMENT_FOR: 'Оплата за: {name}',
    LAST_PAYMENT: 'Последний платеж',
    NO_FIRST_PAYMENT: 'Пользователь еще не произвел первый платеж',
    QR_SORT_BY_DATE: 'По дате создания QR',
    QR_SORT_NEW: 'Новые',
    QR_SORT_OLD: 'Старые',
    ENTER_PURPOSE: 'Введите назначение',
    LAST_TRANSACTION_DATE_TIME: 'По последнему платежу',
    NO_PERSONAL_QR: 'У вас нет сгенерированных персональных QR',
    AMOUNT_EDITING: 'Редактирование суммы',
    AMOUNT_EDITING_DENIED: 'Не разрешено',
    AMOUNT_EDITING_ALLOWED: 'Разрешено',
    PERSONAL_QR_UPDATED:
      'После редактирования данные и сумма персонального QR обновляются. Сохраните изменённый QR и распечатайте или скачайте его заново.',
  },
  INSTALLMENT: {
    TITLE: 'Продажи в рассрочку',

    TABS: {
      HISTORY: 'История',
      OUTLET: 'Точки',
      ABOUT: 'О продуктах',
    },
    FILTER: {
      THREE: 'За 3 дня',
      WEEK: 'За 7 дней',
      MONTH: 'За 30 дней',
    },
    STATUS: {
      ALL: 'Все',
      UNDER_REVIEW: 'В обработке',
      AWAITING_DELIVERY_OF_GOODS: 'Ждёт подтверждения',
      CREDITING_FUNDS: 'Зачисляем деньги на ваш счёт',
      ISSUED: 'Выполнена',
      REFUSED: 'Отклонена',
      ACTIVE: 'Активный',
      NON_ACTIVE: 'Неактивный',
      IN_PROCESS: '@:INSTALLMENT.STATUS.UNDER_REVIEW',
      ACCEPTED: '@:INSTALLMENT.STATUS.AWAITING_DELIVERY_OF_GOODS',
      PROCESSED: '@:INSTALLMENT.STATUS.ISSUED',
      REJECTED: '@:INSTALLMENT.STATUS.REFUSED',
      ERROR: 'В ошибке',
    },
    FILL_FIELD: 'Введите причину отмены',
    INCOMING_FOR: 'Доход за {day} д.',
    CONNECT: 'Подключить {product}',
    EMPTY: 'Ничего не нашли',
    PERIOD: 'Период действия',
    PERIOD_INFO: 'Приём оплаты рассрочкой продлевается автоматически. Если хотите отключить, обратитесь в банк',
    TERM_COMMISSION: 'Срок и комиссия',
    CONTACT_INFO: 'Контактная информация',
    CONTACT_PERSON: 'Контактное лицо',
    MY_CATEGORY: 'Моя категория',
    GO_TO_SALES: 'Перейти в продажи',
    EMAIL: 'Email',
    TRY_AGAIN: 'Попробовать ещё раз',
    TO_SALE_LIST: 'К списку продаж',
    CONFIRM_SALE: 'Подтвердить продажу',
    SALE_REJECT: 'Продажа отклонена',
    SALE_CONFIRMED: 'Продажа подтверждена',
    SALE: 'Продажа',
    DETAILS: 'Подробности',
    CONTRACT_NUMBER: 'Номер договора',
    REPAYMENT_PERIOD: 'Срок погашения',
    CUSTOMER: 'Покупатель',
    REJECT_TITLE: 'Почему хотите отклонить?',
    REJECT_SALE: 'Отклонить продажу',
    PLACEHOLDER_REJECT: 'Не выдаю этот товар в рассрочку',
    REJECT_REASON: 'Причина отклонения',
    MONTH: 'мес.',
    PROFIT_ALL_TIME: 'Доход за всё время',
    ADDRESS: 'Адрес офиса банка',
    FROM:
      '<span class="entity-installment-product-card__label">От</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',
    TO:
      '<span class="entity-installment-product-card__label">До</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',

    ONBOARDING: {
      TO_SALE: 'Обратно в Продукты',
      PAY_DA: {
        TITLE_PRODUCT: 'Увеличивайте продажи c ПАЙДА!',
        TITLE_BANK: 'Обратитесь в офис банка,\nгде открывали расчётный счёт',
        DESCRIPTION_CONNECT: 'Не забудьте взять паспорт. Подключим приём\nоплаты ПАЙДА! — это не займёт много времени',
        DESCRIPTION_MONEY: 'Вы получаете все деньги сразу,\nа покупатель платит банку частями',
        DESCRIPTION_SALE: 'Сможете увеличить продажи и средний чек',
        DESCRIPTION_QR: 'Оплата по QR-коду точки продаж',
        BUTTON_GET_CASH: 'Хочу больше продаж',
        SEND_APPLICATION_TO_CONNECT: 'Отправьте заявку на подключение',
        CONTACT_NAME: 'Имя',
        SEND_APPLICATION: 'Отправить заявку',
        APPLICATION_SENT: 'Заявка отправлена',
        APPLICATION_SENT_HINT: 'Скоро позвоним вам, чтобы обсудить детали',
        CREATE_OUTLET: 'Создать точку сейчас',
        CREATE_OUTLET_LATER: 'Создать позже',
        CREATE_DESCRIPTION: 'Чтобы продавать через ПАЙДА! нужна точка продаж — вы можете создать её сейчас',
      },
      TEZ_CREDIT: {
        TITLE_PRODUCT: 'Продавайте в ТЕЗ-рассрочку',
        TITLE_BANK: 'Обратитесь в офис банка,\nгде открывали расчётный счёт',
        DESCRIPTION_CONNECT:
          'Не забудьте взять паспорт. Подключим приём\nоплаты ТЕЗ-рассрочкой — это не займёт много\nвремени',
        DESCRIPTION_MONEY: 'Вы получаете все деньги сразу,\nа покупатель платит банку частями',
        DESCRIPTION_SALE: 'Сможете увеличить продажи и средний чек',
        DESCRIPTION_QR: 'Покупатель оформит рассрочку\nпо QR-коду вашей точки продаж,\nа вы подтвердите выдачу товара',
        BUTTON_GET_CASH: 'Как начать продавать',
      },
    },
  },
  NPT: {
    BANNER: {
      TITLE: 'Погасите долг перед налоговой, чтобы совершать переводы!',
      DESCRIPTION: 'Обратитесь в офис банка, где открывали счёт',
    },
    DIALOG: {
      TITLE: 'Долги в налоговой',
      DEBT: 'Долг {number}',
      PAYMENT_REQUEST: 'Налоговое платежное требование',
      NOTICE: 'Извещение',
    },
  },
  INVOICE: {
    LIST_TITLE: 'Счета на оплату',
    TITLE: 'Счёт на оплату',
    DIALOG: {
      CONFIRM_CLOSE: {
        LABEL: 'Черновик счёта на оплату не сохранится',
      },
    },
    ISSUE: 'Выставить счёт',
    INCOMING: 'Входящие',
    OUTGOING: 'Исходящие',
    PRODUCT: 'Товары и услуги',
    ALLOW_PARTIAL_PAYMENT: 'Разрешить частичную оплату',
    MOBILE_TABS: {
      INVOICES: 'Счета',
      CATALOG: 'Каталог',
    },
    OPEN_INVOICE: 'Открыть счёт',
    AVAILABLE_AROUND_THE_CLOCK: 'Доступен круглосуточно',
    PAYMENT_AMOUNT: 'Сумма платежа',
    CREATED_AT: 'Создано',
    EXPIRES_AT: 'Истекает',
    IN_PROGRESS: 'В работе',
    PAY: 'Оплатить',
    REJECT: 'Отклонить',
    ISSUED_INVOICE: 'Выставленный счёт',
    INVOICE_PAYMENT: 'Платеж по счёту',
    INTRABANK_TRANSFER_BY_INVOICE: 'Внутрибанковский перевод по счёту на оплату',
    PRODUCTS_MORE: '+ {count} товаров',
    EMPTY_CATALOG:
      'В каталоге пока нет товаров и услуг\nСоздайте первую позицию и используйте её при выставлении счетов',
    EMPTY_OUTGOING:
      'У вас пока нет исходящих счетов\nВыставьте первый счёт, чтобы запросить оплату за товары или услуги',
    EMPTY_OUTGOING_ACTION: 'Выставить счёт',
    EMPTY_INCOMING:
      'У вас пока нет входящих счетов\nЗдесь будут отображаться счета, которые выставят вам другие компании',
    COUNTERPARTY: {
      SUPPLIER: 'Поставщик',
      BUYER: 'Покупатель',
    },
    TYPE_SHORT: {
      INDIVIDUAL: 'физ. лицу',
      LEGAL: 'юр. лицу',
    },
    TYPE_FULL: {
      INDIVIDUAL: 'Счёт на оплату физ. лицу',
      LEGAL: 'Счёт на оплату юридическому лицу / ИП',
    },
    TYPE_MOBILE: {
      INDIVIDUAL: 'Счёт на оплату физ. лицу',
      LEGAL: 'Счёт на оплату юр. лицу/ИП',
    },
    TYPE_FILTER: {
      TITLE: 'Тип счета',
      LEGAL: 'Юр. лица / ИП',
      INDIVIDUAL: 'Физ. лица',
    },
    SERVICE_DIALOG: {
      TRIGGER: 'Условия и возможности сервиса',
      TITLE: 'Условия и возможности сервиса',
      DESCRIPTION:
        'Сервис счетов на оплату позволяет быстро принимать оплату за товары и услуги — внутри Оптима Банка и из других банков.',
      INDIVIDUAL_DESCRIPTION:
        'Счета на оплату физическим лицам позволяют быстро принимать оплату за товары и услуги внутри Оптима Банка.',
      TARIFFS_TITLE: 'Тарифы',
      FOR_SOLE_PROPRIETORS: 'Для ИП',
      FOR_LEGAL_ENTITIES: 'Для юридических лиц',
      INTERNAL_BANK_LABEL: 'внутри Оптима Банка',
      OTHER_BANKS_LABEL: 'из других банков',
      SOLE_INTERNAL_VALUE: '0,8%',
      SOLE_OTHER_VALUE: '1%',
      LEGAL_INTERNAL_VALUE: '1%',
      LEGAL_OTHER_VALUE: '1%',
      TARIFFS_NOTE: 'Для отдельных клиентов могут действовать индивидуальные тарифы.',
      FEATURES_TITLE: 'Возможности',
      FEATURE_1: 'Выставление счетов внутри банка и в другие банки',
      FEATURE_2: 'Моментальное зачисление денежных средств',
      FEATURE_3: 'Автоматическое обновление статуса оплаты',
      FEATURE_4: 'Работа сервиса 24/7',
      FEATURE_5: 'Интеграция с 1С',
      ACTION: 'Вернуться назад',
    },
    STATUS_INFO_DIALOG: {
      REJECTED_TITLE: 'Статус Отклонен',
      REJECTED_DESCRIPTION: 'Плательщик отказался от оплаты счёта.',
      CANCELLED_TITLE: 'Статус Отменен',
      CANCELLED_DESCRIPTION: 'Счёт отменён выставившей стороной до оплаты.',
      EXPIRED_TITLE: 'Статус Истёк',
      EXPIRED_DESCRIPTION: 'Срок оплаты истёк. Счёт больше недействителен.',
      BACK: 'Вернуться назад',
    },
    COUNT_WIDGET: {
      TITLE: 'У вас {count} входящий счёт на оплату',
      ACTION: 'Перейти к счету',
    },
    PRODUCTS_TABLE: {
      SEARCH_PLACEHOLDER: 'Найти',
      ADD_BUTTON: 'Добавить товар или услугу',
      ADD_TITLE: 'Добавить товар или услугу',
      CODE: 'Код',
      NAME: 'Название',
      UNIT: 'Ед.изм.',
      QUANTITY: 'Кол-во',
      PRICE: 'Цена, с налогами',
      TAXES: 'Налоги',
      ACTIONS: 'Действия',
      DELETE_TITLE: 'Хотите удалить товар?',
      DELETE_MESSAGE: 'Данные товара «{name}» не сохранятся',
      SAVED_TITLE: 'Изменения сохранены',
      PRODUCT_SAVED_TITLE: 'Товар сохранен в каталоге',
      EDIT_TITLE: 'Редактирование',
      NAME_LABEL: 'Название',
      PRICE_LABEL: 'Цена, с налогами',
      UNIT_LABEL: 'Единица измерения',
      VAT_LABEL: 'НДС',
      SALES_TAX_LABEL: 'НСП',
      VAT_RATE: 'НДС',
      SALES_TAX_RATE: 'НСП',
      AMOUNT: 'Сумма',
      EMPTY: 'Пока нет товаров/услуг',
      CANCEL_TITLE: 'Не добавлять товар?',
      CANCEL_MESSAGE: 'Данные не сохранятся, если вы их вводили',
    },
    CREATE_PARAMS_TITLE: 'Параметры счёта',
    CREATE_RECIPIENT_TITLE: 'Получатель счёта',
    PRODUCTS_TABLE_LIMIT_HINT: 'В счете на оплату можно создать до {count} товаров и/или услуг на сумму до {sum} сом',
    CASH_NUMBER_LABEL: 'Номер кассы',
    ACCOUNT_NUMBER_LABEL: '№ счёта на оплату',
    ACCOUNT_NUMBER_AUTO_HINT: 'Если номер счета не указан, он будет присвоен автоматически',
    VALIDITY_PERIOD_LABEL: 'Срок действия',
    VALIDITY_EXPIRES_AT_HINT: 'Дата истечения срока: {date}',
    ACCOUNT_NUMBER: '№ счёта',
    VALIDITY_DAYS: 'Количество дней актуальности счета',
    VALIDITY_DAYS_HINT: 'Если оставить пустым или 0, счёт будет актуален до 23:59',
    VALIDITY_DAYS_RANGE: 'Введите значение от 0 до 30',
    SALE_POINT_ACCOUNT: 'Средства поступят на счёт - {account}',
    RECIPIENT_NAME_INN: 'Наименование/ИНН получателя',
    RECIPIENT_SEARCHING: 'Поиск получателя…',
    PURPOSE_COMMENT: 'Назначение/Комментарий',
    PURPOSE_PAYMENT_HINT: 'Укажите назначение: за что или для кого платеж',
    CONTINUE: 'Продолжить',
    STEPS: {
      REQUISITES: 'Реквизиты',
      PRODUCTS: 'Товары и/или услуги',
    },
    CREATE_INDIVIDUAL: 'Счёт на оплату физ. лицу',
    CREATE_LEGAL: 'Счёт на оплату юридическому лицу / ИП',
    CONFIRM_ISSUE_TITLE: 'Счёт на оплату сформирован.',
    CONFIRM_ISSUE_MESSAGE: 'Выберите способ отправки',
    CONFIRM_ISSUE_ACTION: 'Отправить через Optima Business',
    SEND_MYSELF_ACTION: 'Отправить самостоятельно',
    DOWNLOAD_TITLE: 'Скачать счёт на оплату',
    DOWNLOAD: 'Скачать',
    BACK_TO_EDIT: 'Вернуться к редактированию',
    HINT: 'Счёт можно выставить только пользователю Optima24',
    SUCCESS_SEND: 'Счёт успешно отправлен',
    SUCCESS_HINT: 'Отследить статус счёта можно в разделе «Счета на оплату», во вкладке «Исходящие»',
    SUCCESS_HINT_CASH: 'Следите за статусом операции в {salePoint}',
    PDF_DOWNLOADED_TITLE: 'PDF-счёт загружен',
    PDF_DOWNLOADED_HINT:
      'Отправьте счёт плательщику любым удобным способом. Отслеживать оплату можно во вкладке «Исходящие».',
    PDF_DOWNLOADED_ACTION: 'Вернуться к счетам',
    DRAFT_SAVED_TITLE: 'Счёт сохранён в черновиках',
    DRAFT_SAVED_HINT: 'Вы можете найти его в разделе «Счета на оплату», во вкладке «Черновик»',
    TO_INVOICES: 'К счетам',
    TO_SIGN: 'На подписание',
    SEND_INVOICE: 'Выставить счёт',
    REVOKED: 'Счет отозван',
    REJECT_QUESTION: 'Отклонить счёт на оплату?',
    RECALL_QUESTION: 'Отозвать счёт на оплату?',
    REJECT_SUCCESS: 'Счёт отклонен',
    EMPTY_SALE_POINT: 'Чтобы выставить счет для оплаты, добавьте точку продаж',
    ASK_SALE_POINT: 'Чтобы выставить счет для оплаты, попросите руководителя добавить точку продаж',
    STATUS: {
      WAITING: 'В ожидании',
      PAID: 'Оплачен',
      EXPIRED: 'Истек',
      CANCELLED_BY_SENDER: 'Отозван',
      REJECTED_BY_PAYER: 'Отклонен',
    },
    RULES: {
      MAX_SUM: 'Сумма оплаты не может быть больше {sum} сом',
    },
    OUTGOING_STATUS: {
      ALL: 'Все',
      ISSUED: 'Выставлен',
      PAID: 'Оплачен',

      PARTIALLY_PAID: 'Частично оплачен',
      REJECTED: 'Отклонен',
      CANCELLED: 'Отменен',
      EXPIRED: 'Истек',
      DRAFT: 'Черновик',
      TITLE: 'Счёт на оплату',
      LEGAL_ENTITY: 'юр. лицу/ИП',
      BUYER_NAME: 'Наименование покупателя',
      COMMENT: 'Комментарий по счёту',
    },
    INCOMING_STATUS: {
      ALL: 'Все',
      ISSUED: 'Выставлен',
      PAID: 'Оплачен',

      PARTIALLY_PAID: 'Частично оплачен',
      REJECTED: 'Отклонен',
      CANCELLED: 'Отменен',
      EXPIRED: 'Истек',
      TITLE: 'Счёт на оплату',
      LEGAL_ENTITY: 'юр. лицу/ИП',
      SELLER_NAME: 'Наименование продавца',
      COMMENT: 'Комментарий по счёту',
    },
    OUTGOING_FILTER: {
      BUYER_NAME: 'Наименование покупателя',
      SORT_AMOUNT: 'Сумма',
      SORT_AMOUNT_ASC: 'По возрастанию',
      SORT_AMOUNT_DESC: 'По убыванию',
    },
    INCOMING_FILTER: {
      SELLER_NAME: 'Наименование продавца',
      SORT_AMOUNT: 'Сумма',
      SORT_AMOUNT_ASC: 'По возрастанию',
      SORT_AMOUNT_DESC: 'По убыванию',
    },
    DETAILS: {
      PURPOSE: 'Назначение/Комментарий',
      OPEN: 'Открыть счёт',
      INVOICE_NUMBER: '№ счёта',
      EXPIRES_AT: 'Дата истечения счёта',
      CREATED_BY: 'Создано',
      INVOICE_TYPE: 'Тип плательщика',
      INVOICE_TYPE_INTERNAL: 'Внутрибанк',
      INVOICE_TYPE_EXTERNAL: 'Межбанк',
      BUYER_TITLE: 'Контрагент',
      BUYER_LABEL: 'ИНН/Наименование',
      PRODUCTS: 'Товары/услуги',
    },
  },
  USER_APPROVE: {
    APPROVE_ACCOUNT: 'Подтвердите аккаунт в офисе банка, \nчтобы открыть все возможности',
    APPROVE_ACCOUNT_SHORT: 'Подтвердите аккаунт',
    APPROVE_ACCOUNT_FOR_OPERATIONS: 'Подтвердите аккаунт в офисе банка, чтобы получить полный доступ к операциям',
    ACCOUNT_NOT_APPROVE: 'Аккаунт не подтверждён',
    CREDIT: {
      TITLE: 'Кредиты и рассрочки',
      DESCRIPTION: 'Подключайте кредитные продукты и рассрочки',
    },
    TRANSFER: {
      TITLE: 'Переводы в другой банк',
      DESCRIPTION: 'Переводите платежи партнёрам  без ограничений',
    },
    LIMITS: {
      TITLE: 'Расширенные лимиты',
      DESCRIPTION: 'Проводите крупные операции без ограничений по сумме',
    },
    LIMIT_TRANSFER: {
      TITLE: '* Лимиты на внутрибанковские переводы:',
      ONE_OPERATION: '• На одну операцию — до 200 000 сом',
      MONTH_OPERATION: '• На месяц — до 400 000 сом',
    },
  },
  BANK_OFFICES: {
    TITLE: 'Карта филиалов',
    SEARCH_PLACEHOLDER: 'Введите адрес филиала',
    EMPTY: 'Филиалы не найдены',
  },
  REQUISITES: {
    TITLE: 'Реквизиты',
    COMPANY_NAME: 'Наименование компании',
    LEGAL_ADDRESS: 'Юридический адрес',
    INTERMEDIARY_BANK: 'БАНК-ПОСРЕДНИК',
    CORRESPONDENT_ACCOUNT: 'Корреспондентский счет',
    IBAN: 'IBAN',
    IKK: 'ИКК',
    BIN: 'БИН',
    SWIFT: 'SWIFT',
    INN: 'ИНН',
    STIN: 'СТИН',
    TIN: 'TIN',
    CNAPS: 'CNAPS банка',
    ACCOUNT_NO: 'Номер счета',
    LOCAL_BIC: 'Локальный банковский идентификатор',
    SWIFT_BIC: 'Международный swift/bic код банка',
    ROUTING_NUMBER: 'Routing number (ABA)',
    KBE: 'Код бюджетной единицы, используемый при платежах в Казахстане',
    INFO: 'Дополнительная информация',
    BENEFICIARY_BANK: 'БАНК-ПОЛУЧАТЕЛЬ',
    PURPOSE: 'Назначение платежа (Ограничение 140 символов)',
    PDF: 'Экспортировать в PDF',
    COPY: 'Скопировать реквизиты',
    INFO_ACCOUNT: 'Инфо по счету',
    HISTORY: 'История',
  },
};
